var $7c83c95c37172fc3$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7c83c95c37172fc3$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7c83c95c37172fc3$var$_DurationFormat_options;
class $7c83c95c37172fc3$var$ListFormatPonyFill {
    formatToParts(members) {
        const parts = [];
        for (const value of members){
            parts.push({
                type: 'element',
                value: value
            });
            parts.push({
                type: 'literal',
                value: ', '
            });
        }
        return parts.slice(0, -1);
    }
}
const $7c83c95c37172fc3$var$ListFormat = typeof Intl !== 'undefined' && Intl.ListFormat || $7c83c95c37172fc3$var$ListFormatPonyFill;
const $7c83c95c37172fc3$var$partsTable = [
    [
        'years',
        'year'
    ],
    [
        'months',
        'month'
    ],
    [
        'weeks',
        'week'
    ],
    [
        'days',
        'day'
    ],
    [
        'hours',
        'hour'
    ],
    [
        'minutes',
        'minute'
    ],
    [
        'seconds',
        'second'
    ],
    [
        'milliseconds',
        'millisecond'
    ]
];
const $7c83c95c37172fc3$var$twoDigitFormatOptions = {
    minimumIntegerDigits: 2
};
class $7c83c95c37172fc3$export$2e2bcd8739ae039 {
    constructor(locale, options = {}){
        $7c83c95c37172fc3$var$_DurationFormat_options.set(this, void 0);
        let style = String(options.style || 'short');
        if (style !== 'long' && style !== 'short' && style !== 'narrow' && style !== 'digital') style = 'short';
        let prevStyle = style === 'digital' ? 'numeric' : style;
        const hours = options.hours || prevStyle;
        prevStyle = hours === '2-digit' ? 'numeric' : hours;
        const minutes = options.minutes || prevStyle;
        prevStyle = minutes === '2-digit' ? 'numeric' : minutes;
        const seconds = options.seconds || prevStyle;
        prevStyle = seconds === '2-digit' ? 'numeric' : seconds;
        const milliseconds = options.milliseconds || prevStyle;
        $7c83c95c37172fc3$var$__classPrivateFieldSet(this, $7c83c95c37172fc3$var$_DurationFormat_options, {
            locale: locale,
            style: style,
            years: options.years || style === 'digital' ? 'short' : style,
            yearsDisplay: options.yearsDisplay === 'always' ? 'always' : 'auto',
            months: options.months || style === 'digital' ? 'short' : style,
            monthsDisplay: options.monthsDisplay === 'always' ? 'always' : 'auto',
            weeks: options.weeks || style === 'digital' ? 'short' : style,
            weeksDisplay: options.weeksDisplay === 'always' ? 'always' : 'auto',
            days: options.days || style === 'digital' ? 'short' : style,
            daysDisplay: options.daysDisplay === 'always' ? 'always' : 'auto',
            hours: hours,
            hoursDisplay: options.hoursDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
            minutes: minutes,
            minutesDisplay: options.minutesDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
            seconds: seconds,
            secondsDisplay: options.secondsDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
            milliseconds: milliseconds,
            millisecondsDisplay: options.millisecondsDisplay === 'always' ? 'always' : 'auto'
        }, "f");
    }
    resolvedOptions() {
        return $7c83c95c37172fc3$var$__classPrivateFieldGet(this, $7c83c95c37172fc3$var$_DurationFormat_options, "f");
    }
    formatToParts(duration) {
        const list = [];
        const options = $7c83c95c37172fc3$var$__classPrivateFieldGet(this, $7c83c95c37172fc3$var$_DurationFormat_options, "f");
        const style = options.style;
        const locale = options.locale;
        for (const [unit, nfUnit] of $7c83c95c37172fc3$var$partsTable){
            const value = duration[unit];
            if (options[`${unit}Display`] === 'auto' && !value) continue;
            const unitStyle = options[unit];
            const nfOpts = unitStyle === '2-digit' ? $7c83c95c37172fc3$var$twoDigitFormatOptions : unitStyle === 'numeric' ? {} : {
                style: 'unit',
                unit: nfUnit,
                unitDisplay: unitStyle
            };
            let formattedValue = new Intl.NumberFormat(locale, nfOpts).format(value);
            if (unit === 'months' && (unitStyle === 'narrow' || style === 'narrow' && formattedValue.endsWith('m'))) formattedValue = formattedValue.replace(/(\d+)m$/, '$1mo');
            list.push(formattedValue);
        }
        return new $7c83c95c37172fc3$var$ListFormat(locale, {
            type: 'unit',
            style: style === 'digital' ? 'short' : style
        }).formatToParts(list);
    }
    format(duration) {
        return this.formatToParts(duration).map((p)=>p.value).join('');
    }
}
$7c83c95c37172fc3$var$_DurationFormat_options = new WeakMap();


const $35876d45cea70903$var$durationRe = /^[-+]?P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
const $35876d45cea70903$export$ab2b613392a6a176 = [
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
const $35876d45cea70903$export$757a451204d10ad6 = (str)=>$35876d45cea70903$var$durationRe.test(str);
class $35876d45cea70903$export$3b11bc38611c5941 {
    constructor(years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0){
        this.years = years;
        this.months = months;
        this.weeks = weeks;
        this.days = days;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.milliseconds = milliseconds;
        this.years || (this.years = 0);
        this.sign || (this.sign = Math.sign(this.years));
        this.months || (this.months = 0);
        this.sign || (this.sign = Math.sign(this.months));
        this.weeks || (this.weeks = 0);
        this.sign || (this.sign = Math.sign(this.weeks));
        this.days || (this.days = 0);
        this.sign || (this.sign = Math.sign(this.days));
        this.hours || (this.hours = 0);
        this.sign || (this.sign = Math.sign(this.hours));
        this.minutes || (this.minutes = 0);
        this.sign || (this.sign = Math.sign(this.minutes));
        this.seconds || (this.seconds = 0);
        this.sign || (this.sign = Math.sign(this.seconds));
        this.milliseconds || (this.milliseconds = 0);
        this.sign || (this.sign = Math.sign(this.milliseconds));
        this.blank = this.sign === 0;
    }
    abs() {
        return new $35876d45cea70903$export$3b11bc38611c5941(Math.abs(this.years), Math.abs(this.months), Math.abs(this.weeks), Math.abs(this.days), Math.abs(this.hours), Math.abs(this.minutes), Math.abs(this.seconds), Math.abs(this.milliseconds));
    }
    static from(durationLike) {
        var _a;
        if (typeof durationLike === 'string') {
            const str = String(durationLike).trim();
            const factor = str.startsWith('-') ? -1 : 1;
            const parsed = (_a = str.match($35876d45cea70903$var$durationRe)) === null || _a === void 0 ? void 0 : _a.slice(1).map((x)=>(Number(x) || 0) * factor);
            if (!parsed) return new $35876d45cea70903$export$3b11bc38611c5941();
            return new $35876d45cea70903$export$3b11bc38611c5941(...parsed);
        } else if (typeof durationLike === 'object') {
            const { years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds } = durationLike;
            return new $35876d45cea70903$export$3b11bc38611c5941(years, months, weeks, days, hours, minutes, seconds, milliseconds);
        }
        throw new RangeError('invalid duration');
    }
    static compare(one, two) {
        const now = Date.now();
        const oneApplied = Math.abs($35876d45cea70903$export$ba4b4889be7cd2f0(now, $35876d45cea70903$export$3b11bc38611c5941.from(one)).getTime() - now);
        const twoApplied = Math.abs($35876d45cea70903$export$ba4b4889be7cd2f0(now, $35876d45cea70903$export$3b11bc38611c5941.from(two)).getTime() - now);
        return oneApplied > twoApplied ? -1 : oneApplied < twoApplied ? 1 : 0;
    }
    toLocaleString(locale, opts) {
        return new (0, $7c83c95c37172fc3$export$2e2bcd8739ae039)(locale, opts).format(this);
    }
}
function $35876d45cea70903$export$ba4b4889be7cd2f0(date, duration) {
    const r = new Date(date);
    if (duration.sign < 0) {
        r.setUTCSeconds(r.getUTCSeconds() + duration.seconds);
        r.setUTCMinutes(r.getUTCMinutes() + duration.minutes);
        r.setUTCHours(r.getUTCHours() + duration.hours);
        r.setUTCDate(r.getUTCDate() + duration.weeks * 7 + duration.days);
        r.setUTCMonth(r.getUTCMonth() + duration.months);
        r.setUTCFullYear(r.getUTCFullYear() + duration.years);
    } else {
        r.setUTCFullYear(r.getUTCFullYear() + duration.years);
        r.setUTCMonth(r.getUTCMonth() + duration.months);
        r.setUTCDate(r.getUTCDate() + duration.weeks * 7 + duration.days);
        r.setUTCHours(r.getUTCHours() + duration.hours);
        r.setUTCMinutes(r.getUTCMinutes() + duration.minutes);
        r.setUTCSeconds(r.getUTCSeconds() + duration.seconds);
    }
    return r;
}
function $35876d45cea70903$export$1ea91570c695dfb2(date, precision = 'second', now = Date.now()) {
    const delta = date.getTime() - now;
    if (delta === 0) return new $35876d45cea70903$export$3b11bc38611c5941();
    const sign = Math.sign(delta);
    const ms = Math.abs(delta);
    const sec = Math.floor(ms / 1000);
    const min = Math.floor(sec / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    const month = Math.floor(day / 30);
    const year = Math.floor(month / 12);
    const i = $35876d45cea70903$export$ab2b613392a6a176.indexOf(precision) || $35876d45cea70903$export$ab2b613392a6a176.length;
    return new $35876d45cea70903$export$3b11bc38611c5941(i >= 0 ? year * sign : 0, i >= 1 ? (month - year * 12) * sign : 0, 0, i >= 3 ? (day - month * 30) * sign : 0, i >= 4 ? (hr - day * 24) * sign : 0, i >= 5 ? (min - hr * 60) * sign : 0, i >= 6 ? (sec - min * 60) * sign : 0, i >= 7 ? (ms - sec * 1000) * sign : 0);
}
function $35876d45cea70903$export$56623f543516c50f(duration, { relativeTo: relativeTo = Date.now() } = {}) {
    relativeTo = new Date(relativeTo);
    if (duration.blank) return duration;
    const sign = duration.sign;
    let years = Math.abs(duration.years);
    let months = Math.abs(duration.months);
    let weeks = Math.abs(duration.weeks);
    let days = Math.abs(duration.days);
    let hours = Math.abs(duration.hours);
    let minutes = Math.abs(duration.minutes);
    let seconds = Math.abs(duration.seconds);
    let milliseconds = Math.abs(duration.milliseconds);
    if (milliseconds >= 900) seconds += Math.round(milliseconds / 1000);
    if (seconds || minutes || hours || days || weeks || months || years) milliseconds = 0;
    if (seconds >= 55) minutes += Math.round(seconds / 60);
    if (minutes || hours || days || weeks || months || years) seconds = 0;
    if (minutes >= 55) hours += Math.round(minutes / 60);
    if (hours || days || weeks || months || years) minutes = 0;
    if (days && hours >= 12) days += Math.round(hours / 24);
    if (!days && hours >= 21) days += Math.round(hours / 24);
    if (days || weeks || months || years) hours = 0;
    const currentYear = relativeTo.getFullYear();
    const currentMonth = relativeTo.getMonth();
    const currentDate = relativeTo.getDate();
    if (days >= 27 || years + months + days) {
        const newMonthDate = new Date(relativeTo);
        newMonthDate.setDate(1);
        newMonthDate.setMonth(currentMonth + months * sign + 1);
        newMonthDate.setDate(0);
        const monthDateCorrection = Math.max(0, currentDate - newMonthDate.getDate());
        const newDate = new Date(relativeTo);
        newDate.setFullYear(currentYear + years * sign);
        newDate.setDate(currentDate - monthDateCorrection);
        newDate.setMonth(currentMonth + months * sign);
        newDate.setDate(currentDate - monthDateCorrection + days * sign);
        const yearDiff = newDate.getFullYear() - relativeTo.getFullYear();
        const monthDiff = newDate.getMonth() - relativeTo.getMonth();
        const daysDiff = Math.abs(Math.round((Number(newDate) - Number(relativeTo)) / 86400000)) + monthDateCorrection;
        const monthsDiff = Math.abs(yearDiff * 12 + monthDiff);
        if (daysDiff < 27) {
            if (days >= 6) {
                weeks += Math.round(days / 7);
                days = 0;
            } else days = daysDiff;
            months = years = 0;
        } else if (monthsDiff <= 11) {
            months = monthsDiff;
            years = 0;
        } else {
            months = 0;
            years = yearDiff * sign;
        }
        if (months || years) days = 0;
    }
    if (years) months = 0;
    if (weeks >= 4) months += Math.round(weeks / 4);
    if (months || years) weeks = 0;
    if (days && weeks && !months && !years) {
        weeks += Math.round(days / 7);
        days = 0;
    }
    return new $35876d45cea70903$export$3b11bc38611c5941(years * sign, months * sign, weeks * sign, days * sign, hours * sign, minutes * sign, seconds * sign, milliseconds * sign);
}
function $35876d45cea70903$export$d2cb509fe1f5058d(duration, opts) {
    const rounded = $35876d45cea70903$export$56623f543516c50f(duration, opts);
    if (rounded.blank) return [
        0,
        'second'
    ];
    for (const unit of $35876d45cea70903$export$ab2b613392a6a176){
        if (unit === 'millisecond') continue;
        const val = rounded[`${unit}s`];
        if (val) return [
            val,
            unit
        ];
    }
    return [
        0,
        'second'
    ];
}


var $4d36b4ad37353f7d$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4d36b4ad37353f7d$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, $4d36b4ad37353f7d$var$_RelativeTimeElement_customTitle, $4d36b4ad37353f7d$var$_RelativeTimeElement_updating, $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get, $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot, $4d36b4ad37353f7d$var$_RelativeTimeElement_getFormattedTitle, $4d36b4ad37353f7d$var$_RelativeTimeElement_resolveFormat, $4d36b4ad37353f7d$var$_RelativeTimeElement_getDurationFormat, $4d36b4ad37353f7d$var$_RelativeTimeElement_getRelativeFormat, $4d36b4ad37353f7d$var$_RelativeTimeElement_getDateTimeFormat, $4d36b4ad37353f7d$var$_RelativeTimeElement_isToday, $4d36b4ad37353f7d$var$_RelativeTimeElement_isCurrentYear, $4d36b4ad37353f7d$var$_RelativeTimeElement_getUserPreferredAbsoluteTimeFormat, $4d36b4ad37353f7d$var$_RelativeTimeElement_updateRenderRootContent, $4d36b4ad37353f7d$var$_RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime, $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated;
const $4d36b4ad37353f7d$var$HTMLElement = globalThis.HTMLElement || null;
const $4d36b4ad37353f7d$var$emptyDuration = new (0, $35876d45cea70903$export$3b11bc38611c5941)();
const $4d36b4ad37353f7d$var$microEmptyDuration = new (0, $35876d45cea70903$export$3b11bc38611c5941)(0, 0, 0, 0, 0, 1);
class $4d36b4ad37353f7d$export$1d6cc3abc67a5072 extends Event {
    constructor(oldText, newText, oldTitle, newTitle){
        super('relative-time-updated', {
            bubbles: true,
            composed: true
        });
        this.oldText = oldText;
        this.newText = newText;
        this.oldTitle = oldTitle;
        this.newTitle = newTitle;
    }
}
function $4d36b4ad37353f7d$var$getUnitFactor(el) {
    if (!el.date) return Infinity;
    if (el.format === 'duration' || el.format === 'elapsed') {
        const precision = el.precision;
        if (precision === 'second') return 1000;
        else if (precision === 'minute') return 60000;
    }
    const ms = Math.abs(Date.now() - el.date.getTime());
    if (ms < 60000) return 1000;
    if (ms < 3600000) return 60000;
    return 3600000;
}
const $4d36b4ad37353f7d$var$dateObserver = new class {
    constructor(){
        this.elements = new Set();
        this.time = Infinity;
        this.timer = -1;
    }
    observe(element) {
        if (this.elements.has(element)) return;
        this.elements.add(element);
        const date = element.date;
        if (date && date.getTime()) {
            const ms = $4d36b4ad37353f7d$var$getUnitFactor(element);
            const time = Date.now() + ms;
            if (time < this.time) {
                clearTimeout(this.timer);
                this.timer = setTimeout(()=>this.update(), ms);
                this.time = time;
            }
        }
    }
    unobserve(element) {
        if (!this.elements.has(element)) return;
        this.elements.delete(element);
    }
    update() {
        clearTimeout(this.timer);
        if (!this.elements.size) return;
        let nearestDistance = Infinity;
        for (const timeEl of this.elements){
            nearestDistance = Math.min(nearestDistance, $4d36b4ad37353f7d$var$getUnitFactor(timeEl));
            timeEl.update();
        }
        this.time = Math.min(3600000, nearestDistance);
        this.timer = setTimeout(()=>this.update(), this.time);
        this.time += Date.now();
    }
}();
class $4d36b4ad37353f7d$export$8f5d2bd03530cdd0 extends $4d36b4ad37353f7d$var$HTMLElement {
    constructor(){
        super(...arguments);
        $4d36b4ad37353f7d$var$_RelativeTimeElement_instances.add(this);
        $4d36b4ad37353f7d$var$_RelativeTimeElement_customTitle.set(this, false);
        $4d36b4ad37353f7d$var$_RelativeTimeElement_updating.set(this, false);
        $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot.set(this, this.shadowRoot ? this.shadowRoot : this.attachShadow ? this.attachShadow({
            mode: 'open'
        }) : this);
        $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated.set(this, null);
    }
    static define(tag = 'relative-time', registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    get timeZone() {
        var _a;
        const tz = ((_a = this.closest('[time-zone]')) === null || _a === void 0 ? void 0 : _a.getAttribute('time-zone')) || this.ownerDocument.documentElement.getAttribute('time-zone');
        return tz || undefined;
    }
    static get observedAttributes() {
        return [
            'second',
            'minute',
            'hour',
            'weekday',
            'day',
            'month',
            'year',
            'time-zone-name',
            'prefix',
            'threshold',
            'tense',
            'precision',
            'format',
            'format-style',
            'no-title',
            'datetime',
            'lang',
            'title',
            'aria-hidden',
            'time-zone'
        ];
    }
    get onRelativeTimeUpdated() {
        return $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated, "f");
    }
    set onRelativeTimeUpdated(listener) {
        if ($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated, "f")) this.removeEventListener('relative-time-updated', $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated, "f"));
        $4d36b4ad37353f7d$var$__classPrivateFieldSet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated, typeof listener === 'object' || typeof listener === 'function' ? listener : null, "f");
        if (typeof listener === 'function') this.addEventListener('relative-time-updated', listener);
    }
    get second() {
        const second = this.getAttribute('second');
        if (second === 'numeric' || second === '2-digit') return second;
    }
    set second(value) {
        this.setAttribute('second', value || '');
    }
    get minute() {
        const minute = this.getAttribute('minute');
        if (minute === 'numeric' || minute === '2-digit') return minute;
    }
    set minute(value) {
        this.setAttribute('minute', value || '');
    }
    get hour() {
        const hour = this.getAttribute('hour');
        if (hour === 'numeric' || hour === '2-digit') return hour;
    }
    set hour(value) {
        this.setAttribute('hour', value || '');
    }
    get weekday() {
        const weekday = this.getAttribute('weekday');
        if (weekday === 'long' || weekday === 'short' || weekday === 'narrow') return weekday;
        if (this.format === 'datetime' && weekday !== '') return this.formatStyle;
    }
    set weekday(value) {
        this.setAttribute('weekday', value || '');
    }
    get day() {
        var _a;
        const day = (_a = this.getAttribute('day')) !== null && _a !== void 0 ? _a : 'numeric';
        if (day === 'numeric' || day === '2-digit') return day;
    }
    set day(value) {
        this.setAttribute('day', value || '');
    }
    get month() {
        const format = this.format;
        let month = this.getAttribute('month');
        if (month === '') return;
        month !== null && month !== void 0 ? month : month = format === 'datetime' ? this.formatStyle : 'short';
        if (month === 'numeric' || month === '2-digit' || month === 'short' || month === 'long' || month === 'narrow') return month;
    }
    set month(value) {
        this.setAttribute('month', value || '');
    }
    get year() {
        var _a;
        const year = this.getAttribute('year');
        if (year === 'numeric' || year === '2-digit') return year;
        if (!this.hasAttribute('year') && new Date().getUTCFullYear() !== ((_a = this.date) === null || _a === void 0 ? void 0 : _a.getUTCFullYear())) return 'numeric';
    }
    set year(value) {
        this.setAttribute('year', value || '');
    }
    get timeZoneName() {
        const name = this.getAttribute('time-zone-name');
        if (name === 'long' || name === 'short' || name === 'shortOffset' || name === 'longOffset' || name === 'shortGeneric' || name === 'longGeneric') return name;
    }
    set timeZoneName(value) {
        this.setAttribute('time-zone-name', value || '');
    }
    get prefix() {
        var _a;
        return (_a = this.getAttribute('prefix')) !== null && _a !== void 0 ? _a : this.format === 'datetime' ? '' : 'on';
    }
    set prefix(value) {
        this.setAttribute('prefix', value);
    }
    get threshold() {
        const threshold = this.getAttribute('threshold');
        return threshold && (0, $35876d45cea70903$export$757a451204d10ad6)(threshold) ? threshold : 'P30D';
    }
    set threshold(value) {
        this.setAttribute('threshold', value);
    }
    get tense() {
        const tense = this.getAttribute('tense');
        if (tense === 'past') return 'past';
        if (tense === 'future') return 'future';
        return 'auto';
    }
    set tense(value) {
        this.setAttribute('tense', value);
    }
    get precision() {
        const precision = this.getAttribute('precision');
        if ((0, $35876d45cea70903$export$ab2b613392a6a176).includes(precision)) return precision;
        if (this.format === 'micro') return 'minute';
        return 'second';
    }
    set precision(value) {
        this.setAttribute('precision', value);
    }
    get format() {
        const format = this.getAttribute('format');
        if (format === 'datetime') return 'datetime';
        if (format === 'relative') return 'relative';
        if (format === 'duration') return 'duration';
        if (format === 'micro') return 'micro';
        if (format === 'elapsed') return 'elapsed';
        return 'auto';
    }
    set format(value) {
        this.setAttribute('format', value);
    }
    get formatStyle() {
        const formatStyle = this.getAttribute('format-style');
        if (formatStyle === 'long') return 'long';
        if (formatStyle === 'short') return 'short';
        if (formatStyle === 'narrow') return 'narrow';
        const format = this.format;
        if (format === 'elapsed' || format === 'micro') return 'narrow';
        if (format === 'datetime') return 'short';
        return 'long';
    }
    set formatStyle(value) {
        this.setAttribute('format-style', value);
    }
    get noTitle() {
        return this.hasAttribute('no-title');
    }
    set noTitle(value) {
        this.toggleAttribute('no-title', value);
    }
    get datetime() {
        return this.getAttribute('datetime') || '';
    }
    set datetime(value) {
        this.setAttribute('datetime', value);
    }
    get date() {
        const parsed = Date.parse(this.datetime);
        return Number.isNaN(parsed) ? null : new Date(parsed);
    }
    set date(value) {
        this.datetime = (value === null || value === void 0 ? void 0 : value.toISOString()) || '';
    }
    connectedCallback() {
        this.update();
    }
    disconnectedCallback() {
        $4d36b4ad37353f7d$var$dateObserver.unobserve(this);
    }
    attributeChangedCallback(attrName, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (attrName === 'title') $4d36b4ad37353f7d$var$__classPrivateFieldSet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_customTitle, newValue !== null && (this.date && $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_getFormattedTitle).call(this, this.date)) !== newValue, "f");
        if (!$4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_updating, "f") && !(attrName === 'title' && $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_customTitle, "f"))) $4d36b4ad37353f7d$var$__classPrivateFieldSet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_updating, (async ()=>{
            await Promise.resolve();
            this.update();
            $4d36b4ad37353f7d$var$__classPrivateFieldSet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_updating, false, "f");
        })(), "f");
    }
    update() {
        const oldText = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot, "f").textContent || this.textContent || '';
        const oldTitle = this.getAttribute('title') || '';
        let newTitle = oldTitle;
        const date = this.date;
        if (typeof Intl === 'undefined' || !Intl.DateTimeFormat || !date) {
            $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot, "f").textContent = oldText;
            return;
        }
        const now = Date.now();
        if (!$4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_customTitle, "f")) {
            newTitle = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_getFormattedTitle).call(this, date) || '';
            if (newTitle && !this.noTitle) this.setAttribute('title', newTitle);
        }
        const duration = (0, $35876d45cea70903$export$1ea91570c695dfb2)(date, this.precision, now);
        const format = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_resolveFormat).call(this, duration);
        let newText = oldText;
        const displayUserPreferredAbsoluteTime = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime).call(this, format);
        if (displayUserPreferredAbsoluteTime) newText = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_getUserPreferredAbsoluteTimeFormat).call(this, date);
        else {
            if (format === 'duration') newText = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_getDurationFormat).call(this, duration);
            else if (format === 'relative') newText = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_getRelativeFormat).call(this, duration);
            else newText = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_getDateTimeFormat).call(this, date);
        }
        if (newText) $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_updateRenderRootContent).call(this, newText);
        else if (this.shadowRoot === $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot, "f") && this.textContent) $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_updateRenderRootContent).call(this, this.textContent);
        if (newText !== oldText || newTitle !== oldTitle) this.dispatchEvent(new $4d36b4ad37353f7d$export$1d6cc3abc67a5072(oldText, newText, oldTitle, newTitle));
        const shouldObserve = format === 'relative' || format === 'duration' || displayUserPreferredAbsoluteTime && ($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_isToday).call(this, date) || $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_isCurrentYear).call(this, date));
        if (shouldObserve) $4d36b4ad37353f7d$var$dateObserver.observe(this);
        else $4d36b4ad37353f7d$var$dateObserver.unobserve(this);
    }
}
$4d36b4ad37353f7d$var$_RelativeTimeElement_customTitle = new WeakMap(), $4d36b4ad37353f7d$var$_RelativeTimeElement_updating = new WeakMap(), $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot = new WeakMap(), $4d36b4ad37353f7d$var$_RelativeTimeElement_onRelativeTimeUpdated = new WeakMap(), $4d36b4ad37353f7d$var$_RelativeTimeElement_instances = new WeakSet(), $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get = function _RelativeTimeElement_lang_get() {
    var _a;
    const lang = ((_a = this.closest('[lang]')) === null || _a === void 0 ? void 0 : _a.getAttribute('lang')) || this.ownerDocument.documentElement.getAttribute('lang');
    try {
        return new Intl.Locale(lang !== null && lang !== void 0 ? lang : '').toString();
    } catch (_b) {
        return 'default';
    }
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_getFormattedTitle = function _RelativeTimeElement_getFormattedTitle(date) {
    return new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
        timeZone: this.timeZone
    }).format(date);
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_resolveFormat = function _RelativeTimeElement_resolveFormat(duration) {
    const format = this.format;
    if (format === 'datetime') return 'datetime';
    if (format === 'duration') return 'duration';
    if (format === 'elapsed') return 'duration';
    if (format === 'micro') return 'duration';
    if ((format === 'auto' || format === 'relative') && typeof Intl !== 'undefined' && Intl.RelativeTimeFormat) {
        const tense = this.tense;
        if (tense === 'past' || tense === 'future') return 'relative';
        if ((0, $35876d45cea70903$export$3b11bc38611c5941).compare(duration, this.threshold) === 1) return 'relative';
    }
    return 'datetime';
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_getDurationFormat = function _RelativeTimeElement_getDurationFormat(duration) {
    const locale = $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get);
    const format = this.format;
    const style = this.formatStyle;
    const tense = this.tense;
    let empty = $4d36b4ad37353f7d$var$emptyDuration;
    if (format === 'micro') {
        duration = (0, $35876d45cea70903$export$56623f543516c50f)(duration);
        empty = $4d36b4ad37353f7d$var$microEmptyDuration;
        if (duration.months === 0 && (this.tense === 'past' && duration.sign !== -1 || this.tense === 'future' && duration.sign !== 1)) duration = $4d36b4ad37353f7d$var$microEmptyDuration;
    } else if (tense === 'past' && duration.sign !== -1 || tense === 'future' && duration.sign !== 1) duration = empty;
    const display = `${this.precision}sDisplay`;
    if (duration.blank) return empty.toLocaleString(locale, {
        style: style,
        [display]: 'always'
    });
    return duration.abs().toLocaleString(locale, {
        style: style
    });
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_getRelativeFormat = function _RelativeTimeElement_getRelativeFormat(duration) {
    const relativeFormat = new Intl.RelativeTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), {
        numeric: 'auto',
        style: this.formatStyle
    });
    const tense = this.tense;
    if (tense === 'future' && duration.sign !== 1) duration = $4d36b4ad37353f7d$var$emptyDuration;
    if (tense === 'past' && duration.sign !== -1) duration = $4d36b4ad37353f7d$var$emptyDuration;
    const [int, unit] = (0, $35876d45cea70903$export$d2cb509fe1f5058d)(duration);
    if (unit === 'second' && int < 10) return relativeFormat.format(0, this.precision === 'millisecond' ? 'second' : this.precision);
    return relativeFormat.format(int, unit);
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_getDateTimeFormat = function _RelativeTimeElement_getDateTimeFormat(date) {
    const formatter = new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), {
        second: this.second,
        minute: this.minute,
        hour: this.hour,
        weekday: this.weekday,
        day: this.day,
        month: this.month,
        year: this.year,
        timeZoneName: this.timeZoneName,
        timeZone: this.timeZone
    });
    return `${this.prefix} ${formatter.format(date)}`.trim();
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_isToday = function _RelativeTimeElement_isToday(date) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), {
        timeZone: this.timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    return formatter.format(now) === formatter.format(date);
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_isCurrentYear = function _RelativeTimeElement_isCurrentYear(date) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), {
        timeZone: this.timeZone,
        year: 'numeric'
    });
    return formatter.format(now) === formatter.format(date);
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_getUserPreferredAbsoluteTimeFormat = function _RelativeTimeElement_getUserPreferredAbsoluteTimeFormat(date) {
    const timeOnlyOptions = {
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
        timeZone: this.timeZone
    };
    if ($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_isToday).call(this, date)) {
        const relativeFormatter = new Intl.RelativeTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), {
            numeric: 'auto'
        });
        let todayText = relativeFormatter.format(0, 'day');
        todayText = todayText.charAt(0).toLocaleUpperCase($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get)) + todayText.slice(1);
        const timeOnly = new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), timeOnlyOptions).format(date);
        return `${todayText} ${timeOnly}`;
    }
    const timeAndDateOptions = Object.assign(Object.assign({}, timeOnlyOptions), {
        day: 'numeric',
        month: 'short'
    });
    if ($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "m", $4d36b4ad37353f7d$var$_RelativeTimeElement_isCurrentYear).call(this, date)) return new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), timeAndDateOptions).format(date);
    return new Intl.DateTimeFormat($4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_instances, "a", $4d36b4ad37353f7d$var$_RelativeTimeElement_lang_get), Object.assign(Object.assign({}, timeAndDateOptions), {
        year: 'numeric'
    })).format(date);
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_updateRenderRootContent = function _RelativeTimeElement_updateRenderRootContent(content) {
    if (this.hasAttribute('aria-hidden') && this.getAttribute('aria-hidden') === 'true') {
        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        span.textContent = content;
        $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot, "f").replaceChildren(span);
    } else $4d36b4ad37353f7d$var$__classPrivateFieldGet(this, $4d36b4ad37353f7d$var$_RelativeTimeElement_renderRoot, "f").textContent = content;
}, $4d36b4ad37353f7d$var$_RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime = function _RelativeTimeElement_shouldDisplayUserPreferredAbsoluteTime(format) {
    var _a;
    if (format === 'duration') return false;
    return this.ownerDocument.documentElement.getAttribute('data-prefers-absolute-time') === 'true' || ((_a = this.ownerDocument.body) === null || _a === void 0 ? void 0 : _a.getAttribute('data-prefers-absolute-time')) === 'true';
};
var $4d36b4ad37353f7d$export$2e2bcd8739ae039 = $4d36b4ad37353f7d$export$8f5d2bd03530cdd0;


const $9ae3409df8482d5d$var$root = typeof globalThis !== 'undefined' ? globalThis : window;
try {
    $9ae3409df8482d5d$var$root.RelativeTimeElement = (0, $4d36b4ad37353f7d$export$8f5d2bd03530cdd0).define();
} catch (e) {
    if (!($9ae3409df8482d5d$var$root.DOMException && e instanceof DOMException && e.name === 'NotSupportedError') && !(e instanceof ReferenceError)) throw e;
}
var $9ae3409df8482d5d$export$2e2bcd8739ae039 = (0, $4d36b4ad37353f7d$export$8f5d2bd03530cdd0);


var $677297121851f781$export$2e2bcd8739ae039 = (0, $9ae3409df8482d5d$export$2e2bcd8739ae039);


var $8c375ce4d4f5e09f$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return n(r, t, e, u, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return function(a) {
                                return n(r, t, e, u, i, a);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return function(a) {
                                return function(o) {
                                    return n(r, t, e, u, i, a, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return function(a) {
                                return function(o) {
                                    return function(f) {
                                        return n(r, t, e, u, i, a, o, f);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, i) {
        return 5 === n.a ? n.f(r, t, e, u, i) : n(r)(t)(e)(u)(i);
    }
    function A6(n, r, t, e, u, i, a) {
        return 6 === n.a ? n.f(r, t, e, u, i, a) : n(r)(t)(e)(u)(i)(a);
    }
    function A7(n, r, t, e, u, i, a, o) {
        return 7 === n.a ? n.f(r, t, e, u, i, a, o) : n(r)(t)(e)(u)(i)(a)(o);
    }
    function A8(n, r, t, e, u, i, a, o, f) {
        return 8 === n.a ? n.f(r, t, e, u, i, a, o, f) : n(r)(t)(e)(u)(i)(a)(o)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, c(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = a(n, r, 0, e); u && (t = e.pop()); u = a(t.a, t.b, 0, e));
        return u;
    }
    function a(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (t > 100) return e.push(c(n, r)), !0;
        for(var i in 0 > n.$ && (n = jr(n), r = jr(r)), n)if (!a(n[i], r[i], t + 1, e)) return !1;
        return !0;
    }
    function o(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = o(n.a, r.a)) || (t = o(n.b, r.b)) ? t : o(n.c, r.c);
        for(; n.b && r.b && !(t = o(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var f = F2(function(n, r) {
        var t = o(n, r);
        return 0 > t ? Lr : t ? _r : Ar;
    });
    function c(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function b(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function s(n) {
        return n;
    }
    function v(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = g(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = g(n.a, r);
        return t;
    }
    var l = {
        $: 0
    };
    function g(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(g);
    function $(n) {
        for(var r = l, t = n.length; t--;)r = g(n[t], r);
        return r;
    }
    function m(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var p = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return $(e);
    }), x = F2(function(n, r) {
        return $(m(r).sort(function(r, t) {
            return o(n(r), n(t));
        }));
    }), w = F2(function(n, r) {
        return n + r;
    }), y = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? u(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), k = Math.cos, E = Math.sin, j = Math.asin, A = Math.ceil, _ = Math.floor, L = Math.log, N = F2(function(n, r) {
        return n + r;
    }), T = F2(function(n, r) {
        return r.split(n);
    }), z = F2(function(n, r) {
        return r.join(n);
    }), q = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(s(e))) return !1;
        }
        return !0;
    });
    function F(n) {
        return n + "";
    }
    function I(n) {
        return {
            $: 2,
            b: n
        };
    }
    var C = I(function(n) {
        return "number" != typeof n ? X("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Fr(n) : !isFinite(n) || n % 1 ? X("an INT", n) : Fr(n);
    }), J = (I(function(n) {
        return "boolean" == typeof n ? Fr(n) : X("a BOOL", n);
    }), I(function(n) {
        return "number" == typeof n ? Fr(n) : X("a FLOAT", n);
    }), I(function(n) {
        return Fr(n);
    }), I(function(n) {
        return "string" == typeof n ? Fr(n) : n instanceof String ? Fr(n + "") : X("a STRING", n);
    })), O = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function D(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var R = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), P = F2(function(n, r) {
        return D(n, [
            r
        ]);
    }), B = F3(function(n, r, t) {
        return D(n, [
            r,
            t
        ]);
    }), G = F7(function(n, r, t, e, u, i, a) {
        return D(n, [
            r,
            t,
            e,
            u,
            i,
            a
        ]);
    }), M = F8(function(n, r, t, e, u, i, a, o) {
        return D(n, [
            r,
            t,
            e,
            u,
            i,
            a,
            o
        ]);
    }), S = F2(function(n, r) {
        try {
            return Y(n, JSON.parse(r));
        } catch (n) {
            return Nr(A2(Tr, "This is not valid JSON! " + n.message, r));
        }
    }), H = F2(function(n, r) {
        return Y(n, r);
    });
    function Y(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Fr(n.c) : X("null", r);
            case 3:
                return K(r) ? Z(n.b, r, $) : X("a LIST", r);
            case 4:
                return K(r) ? Z(n.b, r, W) : X("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return X("an OBJECT with a field named `" + t + "`", r);
                var e = Y(n.b, r[t]);
                return Et(e) ? e : Nr(A2(zr, t, e.a));
            case 7:
                var u = n.e;
                return K(r) ? r.length > u ? (e = Y(n.b, r[u]), Et(e) ? e : Nr(A2(qr, u, e.a))) : X("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : X("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || K(r)) return X("an OBJECT", r);
                var i = l;
                for(var a in r)if (r.hasOwnProperty(a)) {
                    if (e = Y(n.b, r[a]), !Et(e)) return Nr(A2(zr, a, e.a));
                    i = g(c(a, e.a), i);
                }
                return Fr(nt(i));
            case 9:
                for(var o = n.f, f = n.g, b = 0; f.length > b; b++){
                    if (e = Y(f[b], r), !Et(e)) return e;
                    o = o(e.a);
                }
                return Fr(o);
            case 10:
                return e = Y(n.b, r), Et(e) ? Y(n.h(e.a), r) : e;
            case 11:
                for(var s = l, v = n.g; v.b; v = v.b){
                    if (e = Y(v.a, r), Et(e)) return e;
                    s = g(e.a, s);
                }
                return Nr(Ir(nt(s)));
            case 1:
                return Nr(A2(Tr, n.a, r));
            case 0:
                return Fr(n.a);
        }
    }
    function Z(n, r, t) {
        for(var e = r.length, u = Array(e), i = 0; e > i; i++){
            var a = Y(n, r[i]);
            if (!Et(a)) return Nr(A2(qr, i, a.a));
            u[i] = a.a;
        }
        return Fr(t(u));
    }
    function K(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function W(n) {
        return A2(kt, n.length, function(r) {
            return n[r];
        });
    }
    function X(n, r) {
        return Nr(A2(Tr, "Expecting " + n, r));
    }
    function U(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return U(n.b, r.b);
            case 6:
                return n.d === r.d && U(n.b, r.b);
            case 7:
                return n.e === r.e && U(n.b, r.b);
            case 9:
                return n.f === r.f && Q(n.g, r.g);
            case 10:
                return n.h === r.h && U(n.b, r.b);
            case 11:
                return Q(n.g, r.g);
        }
    }
    function Q(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!U(n[e], r[e])) return !1;
        return !0;
    }
    var V = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function nn(n) {
        return n;
    }
    function rn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function tn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var en = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), un = 0;
    function an(n) {
        var r = {
            $: 0,
            e: un++,
            f: n,
            g: null,
            h: []
        };
        return vn(r), r;
    }
    function on(n) {
        return tn(function(r) {
            r(rn(an(n)));
        });
    }
    function fn(n, r) {
        n.h.push(r), vn(n);
    }
    var cn = F2(function(n, r) {
        return tn(function(t) {
            fn(n, r), t(rn(0));
        });
    }), bn = !1, sn = [];
    function vn(n) {
        if (sn.push(n), !bn) {
            for(bn = !0; n = sn.shift();)dn(n);
            bn = !1;
        }
    }
    function dn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, vn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var ln = {};
    function gn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function hn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, i = n.e, a = n.f;
        function o(n) {
            return A2(en, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : i && a ? A4(e, t, o.i, o.j, n) : A3(e, t, i ? o.i : o.j, n);
                }
            });
        }
        return t.h = an(A2(en, o, n.b));
    }
    var $n = F2(function(n, r) {
        return tn(function(t) {
            n.g(r), t(rn(0));
        });
    }), mn = F2(function(n, r) {
        return A2(cn, n.h, {
            $: 0,
            a: r
        });
    });
    function pn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function xn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var wn = [], yn = !1;
    function kn(n, r, t) {
        if (wn.push({
            p: n,
            q: r,
            r: t
        }), !yn) {
            yn = !0;
            for(var e; e = wn.shift();)En(e.p, e.q, e.r);
            yn = !1;
        }
    }
    function En(n, r, t) {
        var e = {};
        for(var u in jn(!0, r, e, null), jn(!1, t, e, null), n)fn(n[u], {
            $: "fx",
            a: e[u] || {
                i: l,
                j: l
            }
        });
    }
    function jn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, i = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? ln[r].e : ln[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: l,
                        j: l
                    }, n ? t.i = g(r, t.i) : t.j = g(r, t.j), t;
                }(n, i, t[u]));
            case 2:
                for(var a = r.m; a.b; a = a.b)jn(n, a.a, t, e);
                return;
            case 3:
                return void jn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var An = "undefined" != typeof document ? document : {};
    function _n(n, r) {
        n.appendChild(r);
    }
    function Ln(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Nn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], i = 0; e.b; e = e.b){
                var a = e.a;
                i += a.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 1,
                c: r,
                d: Gn(t),
                e: u,
                f: n,
                b: i
            };
        });
    }), Tn = Nn(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], i = 0; e.b; e = e.b){
                var a = e.a;
                i += a.b.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 2,
                c: r,
                d: Gn(t),
                e: u,
                f: n,
                b: i
            };
        });
    })(void 0);
    var zn, qn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Fn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), In = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Cn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Jn = F3(function(n, r, t) {
        return {
            $: "a4",
            n: r,
            o: {
                f: n,
                o: t
            }
        };
    }), On = /^script$/i, Dn = /^(on|formAction$)/i, Rn = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, Pn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Bn(n) {
        return Pn.test(n) ? "" : n;
    }
    function Gn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, i = t.o;
            if ("a2" !== e) {
                var a = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Mn(a, u, i) : a[u] = i;
            } else "className" === u ? Mn(r, u, nn(i)) : r[u] = nn(i);
        }
        return r;
    }
    function Mn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Sn(n, r) {
        var t = n.$;
        if (5 === t) return Sn(n.k || (n.k = n.m()), r);
        if (0 === t) return An.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var i = {
                j: u,
                p: r
            };
            return (a = Sn(e, i)).elm_event_node_ref = i, a;
        }
        if (3 === t) return Hn(a = n.h(n.g), r, n.d), a;
        var a = n.f ? An.createElementNS(n.f, n.c) : An.createElement(n.c);
        Hn(a, r, n.d);
        for(var o = n.e, f = 0; o.length > f; f++)_n(a, Sn(1 === t ? o[f] : o[f].b, r));
        return a;
    }
    function Hn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Yn(n, u) : "a0" === e ? Wn(n, r, u) : "a3" === e ? Zn(n, u) : "a4" === e ? Kn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Yn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Zn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Kn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, i = e.o;
            void 0 !== i ? n.setAttributeNS(u, t, i) : n.removeAttributeNS(u, t);
        }
    }
    function Wn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var i = t[u], a = e[u];
            if (i) {
                if (a) {
                    if (a.q.$ === i.$) {
                        a.q = i;
                        continue;
                    }
                    n.removeEventListener(u, a);
                }
                a = Xn(r, i), n.addEventListener(u, a, zn && {
                    passive: 2 > Nt(i)
                }), e[u] = a;
            } else n.removeEventListener(u, a), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                zn = !0;
            }
        }));
    } catch (n) {}
    function Xn(n, r) {
        function t(r) {
            var e = t.q, u = Y(e.a, r);
            if (Et(u)) {
                for(var i, a = Nt(e), o = u.a, f = a ? 3 > a ? o.a : o.G : o, c = 1 == a ? o.b : 3 == a && o.av, b = (c && r.stopPropagation(), (2 == a ? o.b : 3 == a && o.as) && r.preventDefault(), n); i = b.j;){
                    if ("function" == typeof i) f = i(f);
                    else for(var s = i.length; s--;)f = i[s](f);
                    b = b.p;
                }
                b(f, c);
            }
        }
        return t.q = r, t;
    }
    function Un(n, r) {
        return n.$ == r.$ && U(n.a, r.a);
    }
    function Qn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Vn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, i = r.$;
            if (u !== i) {
                if (1 !== u || 2 !== i) return void Qn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), i = 1;
            }
            switch(i){
                case 5:
                    for(var a = n.l, o = r.l, f = a.length, c = f === o.length; c && f--;)c = a[f] === o[f];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var b = [];
                    return Vn(n.k, r.k, b, 0), void (b.length > 0 && Qn(t, 1, e, b));
                case 4:
                    for(var s = n.j, v = r.j, d = !1, l = n.k; 4 === l.$;)d = !0, "object" != typeof s ? s = [
                        s,
                        l.j
                    ] : s.push(l.j), l = l.k;
                    for(var g = r.k; 4 === g.$;)d = !0, "object" != typeof v ? v = [
                        v,
                        g.j
                    ] : v.push(g.j), g = g.k;
                    return d && s.length !== v.length ? void Qn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(s, v) : s === v) || Qn(t, 2, e, v), void Vn(l, g, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Qn(t, 3, e, r.a));
                case 1:
                    return void nr(n, r, t, e, tr);
                case 2:
                    return void nr(n, r, t, e, er);
                case 3:
                    if (n.h !== r.h) return void Qn(t, 0, e, r);
                    var h = rr(n.d, r.d);
                    h && Qn(t, 4, e, h);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Qn(t, 5, e, $));
            }
        }
    }
    function nr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var i = rr(n.d, r.d);
            i && Qn(t, 4, e, i), u(n, r, t, e);
        } else Qn(t, 0, e, r);
    }
    function rr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var i = n[u], a = r[u];
                i === a && "value" !== u && "checked" !== u || "a0" === t && Un(i, a) || ((e = e || {})[u] = a);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = rr(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var f in r)f in n || ((e = e || {})[f] = r[f]);
        return e;
    }
    function tr(n, r, t, e) {
        var u = n.e, i = r.e, a = u.length, o = i.length;
        a > o ? Qn(t, 6, e, {
            v: o,
            i: a - o
        }) : o > a && Qn(t, 7, e, {
            v: a,
            e: i
        });
        for(var f = o > a ? a : o, c = 0; f > c; c++){
            var b = u[c];
            Vn(b, i[c], t, ++e), e += b.b || 0;
        }
    }
    function er(n, r, t, e) {
        for(var u = [], i = {}, a = [], o = n.e, f = r.e, c = o.length, b = f.length, s = 0, v = 0, d = e; c > s && b > v;){
            var l = (A = o[s]).a, g = (_ = f[v]).a, h = A.b, $ = _.b, m = void 0, p = void 0;
            if (l !== g) {
                var x = o[s + 1], w = f[v + 1];
                if (x) {
                    var y = x.a, k = x.b;
                    p = g === y;
                }
                if (w) {
                    var E = w.a, j = w.b;
                    m = l === E;
                }
                if (m && p) Vn(h, j, u, ++d), ir(i, u, l, $, v, a), d += h.b || 0, ar(i, u, l, k, ++d), d += k.b || 0, s += 2, v += 2;
                else if (m) d++, ir(i, u, g, $, v, a), Vn(h, j, u, d), d += h.b || 0, s += 1, v += 2;
                else if (p) ar(i, u, l, h, ++d), d += h.b || 0, Vn(k, $, u, ++d), d += k.b || 0, s += 2, v += 1;
                else {
                    if (!x || y !== E) break;
                    ar(i, u, l, h, ++d), ir(i, u, g, $, v, a), d += h.b || 0, Vn(k, j, u, ++d), d += k.b || 0, s += 2, v += 2;
                }
            } else Vn(h, $, u, ++d), d += h.b || 0, s++, v++;
        }
        for(; c > s;){
            var A;
            d++, ar(i, u, (A = o[s]).a, h = A.b, d), d += h.b || 0, s++;
        }
        for(; b > v;){
            var _, L = L || [];
            ir(i, u, (_ = f[v]).a, _.b, void 0, L), v++;
        }
        (u.length > 0 || a.length > 0 || L) && Qn(t, 8, e, {
            w: u,
            x: a,
            y: L
        });
    }
    var ur = "_elmW6BL";
    function ir(n, r, t, e, u, i) {
        var a = n[t];
        if (!a) return i.push({
            r: u,
            A: a = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = a);
        if (1 === a.c) {
            i.push({
                r: u,
                A: a
            }), a.c = 2;
            var o = [];
            return Vn(a.z, e, o, a.r), a.r = u, void (a.s.s = {
                w: o,
                A: a
            });
        }
        ir(n, r, t + ur, e, u, i);
    }
    function ar(n, r, t, e, u) {
        var i = n[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var a = [];
                return Vn(e, i.z, a, u), void Qn(r, 9, u, {
                    w: a,
                    A: i
                });
            }
            ar(n, r, t + ur, e, u);
        } else {
            var o = Qn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function or(n, r, t, e) {
        fr(n, r, t, 0, 0, r.b, e);
    }
    function fr(n, r, t, e, u, i, a) {
        for(var o = t[e], f = o.r; f === u;){
            var c = o.$;
            if (1 === c) or(n, r.k, o.s, a);
            else if (8 === c) o.t = n, o.u = a, (b = o.s.w).length > 0 && fr(n, r, b, 0, u, i, a);
            else if (9 === c) {
                o.t = n, o.u = a;
                var b, s = o.s;
                s && (s.A.s = n, (b = s.w).length > 0 && fr(n, r, b, 0, u, i, a));
            } else o.t = n, o.u = a;
            if (!(o = t[++e]) || (f = o.r) > i) return e;
        }
        var v = r.$;
        if (4 === v) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return fr(n, d, t, e, u + 1, i, n.elm_event_node_ref);
        }
        for(var l = r.e, g = n.childNodes, h = 0; l.length > h; h++){
            u++;
            var $ = 1 === v ? l[h] : l[h].b, m = u + ($.b || 0);
            if (!(u > f || f > m || (o = t[e = fr(g[h], $, t, e, u, m, a)]) && (f = o.r) <= i)) return e;
            u = m;
        }
        return e;
    }
    function cr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, i = br(u, e);
            u === n && (n = i);
        }
        return n;
    }
    function br(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Sn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Hn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return cr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var i = (t = r.s).e, a = n.childNodes[e = t.v]; i.length > e; e++)n.insertBefore(Sn(i[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = cr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = An.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                _n(t, 2 === u.c ? u.s : Sn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = cr(n, t.w);
                    for(var u = t.x, i = 0; u.length > i; i++){
                        var a = u[i], o = a.A, f = 2 === o.c ? o.s : Sn(o.z, r.u);
                        n.insertBefore(f, n.childNodes[a.r]);
                    }
                    return e && _n(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function sr(n) {
        if (3 === n.nodeType) return Ln(n.textContent);
        if (1 !== n.nodeType) return Ln("");
        for(var r = l, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = g(A2(Cn, u.name, u.value), r);
        }
        var i = n.tagName.toLowerCase(), a = l, o = n.childNodes;
        for(e = o.length; e--;)a = g(sr(o[e]), a);
        return A3(Tn, i, r, a);
    }
    var vr = F4(function(n, r, t, e) {
        return function(n, r, t, e, i, a) {
            var o = A2(H, n, r ? r.flags : void 0);
            Et(o) || u(2);
            var f = {}, c = t(o.a), b = c.a, s = a(d, b), v = function(n, r) {
                var t;
                for(var e in ln){
                    var u = ln[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = hn(u, r);
                }
                return t;
            }(f, d);
            function d(n, r) {
                var t = A2(e, n, b);
                s(b = t.a, r), kn(f, t.b, i(b));
            }
            return kn(f, c.b, i(b)), v ? {
                ports: v
            } : {};
        }(r, e, n.by, n.bM, n.bJ, function(r, t) {
            var u = n.bN, i = e.node, a = sr(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (dr(e), r(n), 1);
                }
                return function(u, i) {
                    n = u, i ? (r(n), 2 === t && (t = 1)) : (0 === t && dr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Vn(n, r, t, 0), t;
                }(a, t);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : (or(n, r, t, e), cr(n, t));
                }(i, a, e, r), a = t;
            });
        });
    }), dr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var lr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, gr = "undefined" != typeof document ? document : lr, hr = "undefined" != typeof window ? window : lr, $r = F3(function(n, r, t) {
        return on(tn(function() {
            function e(n) {
                an(t(n));
            }
            return n.addEventListener(r, e, zn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), mr = F2(function(n, r) {
        var t = Y(n, r);
        return Et(t) ? Jr(t.a) : Or;
    }), pr = F3(function(n, r, t) {
        return tn(function(e) {
            function u(n) {
                e(r(t.aE.a(n)));
            }
            var i = new XMLHttpRequest;
            i.addEventListener("error", function() {
                u(Ut);
            }), i.addEventListener("timeout", function() {
                u(ne);
            }), i.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? Xt : Kt, function(n) {
                        return {
                            be: n.responseURL,
                            bH: n.status,
                            bI: n.statusText,
                            aI: xr(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.aE.b, i));
            }), ee(t.bc) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || an(A2(ue, n, c(t, Vt({
                        bG: e.loaded,
                        a8: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || an(A2(ue, n, c(t, Qt({
                        bE: e.loaded,
                        a8: e.lengthComputable ? Jr(e.total) : Or
                    }))));
                });
            }(n, i, t.bc.a);
            try {
                i.open(t.bA, t.be, !0);
            } catch (n) {
                return u(Wt(t.be));
            }
            return function(n, r) {
                for(var t = r.aI; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.bK.a || 0, n.responseType = r.aE.d, n.withCredentials = r.bm;
            }(i, t), t.bo.a && i.setRequestHeader("Content-Type", t.bo.a), i.send(t.bo.b), function() {
                i.c = !0, i.abort();
            };
        });
    });
    function xr(n) {
        if (!n) return te;
        for(var r = te, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], i = u.indexOf(": ");
            if (i > 0) {
                var a = u.substring(0, i), o = u.substring(i + 2);
                r = A3(me, a, function(n) {
                    return Jr(ee(n) ? o + ", " + n.a : o);
                }, r);
            }
        }
        return r;
    }
    var wr = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), yr = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), kr = h, Er = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, i = A3(n, t.b, t.c, A3(Er, n, r, t.e));
            n = u, r = i, t = e;
        }
    }), jr = function(n) {
        return A3(Er, F3(function(n, r, t) {
            return A2(kr, c(n, r), t);
        }), l, n);
    }, Ar = 1, _r = 2, Lr = 0, Nr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), zr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Fr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ir = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Cr = w, Jr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Or = {
        $: 1
    }, Dr = q, Rr = V, Pr = F, Br = F2(function(n, r) {
        return A2(z, n, m(r));
    }), Gr = F2(function(n, r) {
        return $(A2(T, n, r));
    }), Mr = function(n) {
        return A2(Br, "\n    ", A2(Gr, "\n", n));
    }, Sr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, i = A2(n, t.a, r);
            n = u, r = i, t = e;
        }
    }), Hr = function(n) {
        return A3(Sr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Yr = p, Zr = F3(function(n, r, t) {
        for(;;){
            if (o(n, r) >= 1) return t;
            var e = n, u = r - 1, i = A2(kr, r, t);
            n = e, r = u, t = i;
        }
    }), Kr = F2(function(n, r) {
        return A3(Zr, n, r, l);
    }), Wr = F2(function(n, r) {
        return A3(Yr, n, A2(Kr, 0, Hr(r) - 1), r);
    }), Xr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Ur = function(n) {
        var r = Xr(n);
        return r >= 97 && 122 >= r;
    }, Qr = function(n) {
        var r = Xr(n);
        return 90 >= r && r >= 65;
    }, Vr = function(n) {
        return Ur(n) || Qr(n) || function(n) {
            var r = Xr(n);
            return 57 >= r && r >= 48;
        }(n);
    }, nt = function(n) {
        return A3(Sr, kr, l, n);
    }, rt = F2(function(n, r) {
        return "\n\n(" + Pr(n + 1) + ") " + Mr(tt(r));
    }), tt = function(n) {
        return A2(et, n, l);
    }, et = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0), isNaN(r) ? Or : Jr(55296 > r || r > 56319 ? c(n[0], n.slice(1)) : c(n[0] + n[1], n.slice(2))));
                    if (1 === e.$) return !1;
                    var u, i = e.a, a = i.b;
                    return (Ur(u = i.a) || Qr(u)) && A2(Dr, Vr, a);
                }();
                n = e, r = A2(kr, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var i = "[" + Pr(n.a) + "]";
                n = e, r = A2(kr, i, r);
                continue n;
            case 2:
                var a = n.a;
                if (a.b) {
                    if (a.b.b) {
                        var o = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(Br, "", nt(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + Pr(Hr(a)) + " ways:";
                        return A2(Br, "\n\n", A2(kr, o, A2(Wr, rt, a)));
                    }
                    n = e = a.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(Br, "", nt(r)) : "!";
                }();
            default:
                var f = n.a, b = n.b;
                return (o = function() {
                    return r.b ? "Problem with the value at json" + A2(Br, "", nt(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Mr(A2(Rr, 4, b)) + "\n\n") + f;
        }
    }), ut = 32, it = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), at = [], ot = A, ft = F2(function(n, r) {
        return L(r) / L(n);
    }), ct = ot(A2(ft, 2, ut)), bt = A4(it, 0, ct, at, at), st = t, vt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dt = F2(function(n, r) {
        return r(n);
    }), lt = _, gt = function(n) {
        return n.length;
    }, ht = F2(function(n, r) {
        return o(n, r) > 0 ? n : r;
    }), $t = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mt = e, pt = F2(function(n, r) {
        for(;;){
            var t = A2(mt, ut, n), e = t.b, u = A2(kr, $t(t.a), r);
            if (!e.b) return nt(u);
            n = e, r = u;
        }
    }), xt = F2(function(n, r) {
        for(;;){
            var t = ot(r / ut);
            if (1 === t) return A2(mt, ut, n).a;
            n = A2(pt, n, l), r = t;
        }
    }), wt = F2(function(n, r) {
        if (r.f) {
            var t = r.f * ut, e = lt(A2(ft, ut, t - 1)), u = n ? nt(r.j) : r.j, i = A2(xt, u, r.f);
            return A4(it, gt(r.h) + t, A2(ht, 5, e * ct), i, r.h);
        }
        return A4(it, gt(r.h), ct, at, r.h);
    }), yt = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(wt, !1, {
                j: e,
                f: t / ut | 0,
                h: u
            });
            var i = vt(A3(st, ut, r, n));
            r -= ut, e = A2(kr, i, e);
        }
    }), kt = F2(function(n, r) {
        if (n > 0) {
            var t = n % ut;
            return A5(yt, r, n - t - ut, n, l, A3(st, t, n - t, r));
        }
        return bt;
    }), Et = function(n) {
        return !n.$;
    }, jt = R, At = P, _t = B, Lt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Tt = function(n) {
        return n;
    }, zt = rn, qt = zt(0), Ft = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, i = e.b;
            if (i.b) {
                var a = i.a, o = i.b;
                if (o.b) {
                    var f = o.a, c = o.b;
                    if (c.b) {
                        var b = c.b;
                        return A2(n, u, A2(n, a, A2(n, f, A2(n, c.a, t > 500 ? A3(Sr, n, r, nt(b)) : A4(Ft, n, r, t + 1, b)))));
                    }
                    return A2(n, u, A2(n, a, A2(n, f, r)));
                }
                return A2(n, u, A2(n, a, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), It = F3(function(n, r, t) {
        return A4(Ft, n, r, 0, t);
    }), Ct = F2(function(n, r) {
        return A3(It, F2(function(r, t) {
            return A2(kr, n(r), t);
        }), l, r);
    }), Jt = en, Ot = F2(function(n, r) {
        return A2(Jt, function(r) {
            return zt(n(r));
        }, r);
    }), Dt = F3(function(n, r, t) {
        return A2(Jt, function(r) {
            return A2(Jt, function(t) {
                return zt(A2(n, r, t));
            }, t);
        }, r);
    }), Rt = function(n) {
        return A3(It, Dt(kr), zt(l), n);
    }, Pt = $n, Bt = F2(function(n, r) {
        var t = r;
        return on(A2(Jt, Pt(n), t));
    });
    ln.Task = gn(qt, F3(function(n, r) {
        return A2(Ot, function() {
            return 0;
        }, Rt(A2(Ct, Bt(n), r)));
    }), F3(function() {
        return zt(0);
    }), F2(function(n, r) {
        return A2(Ot, n, r);
    })), pn("Task");
    var Gt = vr, Mt = O, St = {
        $: 0
    }, Ht = xn, Yt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zt = S, Kt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Wt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xt = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ut = {
        $: 2
    }, Qt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ne = {
        $: 1
    }, re = {
        $: -2
    }, te = re, ee = function(n) {
        return !n.$;
    }, ue = mn, ie = f, ae = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Or;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(ie, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Jr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), oe = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), fe = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(oe, n, r, t, e, u);
            var i = e.d;
            return a = e.e, A5(oe, 0, e.b, e.c, A5(oe, 1, i.b, i.c, i.d, i.e), A5(oe, 1, r, t, a, u));
        }
        var a, o = u.b, f = u.c, c = u.d, b = u.e;
        return -1 !== e.$ || e.a ? A5(oe, n, o, f, A5(oe, 0, r, t, e, c), b) : A5(oe, 0, r, t, A5(oe, 1, e.b, e.c, e.d, a = e.e), A5(oe, 1, o, f, c, b));
    }), ce = F3(function(n, r, t) {
        if (-2 === t.$) return A5(oe, 0, n, r, re, re);
        var e = t.a, u = t.b, i = t.c, a = t.d, o = t.e;
        switch(A2(ie, n, u)){
            case 0:
                return A5(fe, e, u, i, A3(ce, n, r, a), o);
            case 1:
                return A5(oe, e, u, r, a, o);
            default:
                return A5(fe, e, u, i, a, A3(ce, n, r, o));
        }
    }), be = F3(function(n, r, t) {
        var e = A3(ce, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(oe, 1, e.b, e.c, e.d, e.e);
    }), se = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return a = t.b, o = t.c, e = t.d, b = t.e, A5(oe, 1, n.b, n.c, A5(oe, 0, r.b, r.c, r.d, r.e), A5(oe, 0, a, o, e, b));
            }
            var e, u = n.d, i = n.e, a = i.b, o = i.c, f = (e = i.d).d, c = e.e, b = i.e;
            return A5(oe, 0, e.b, e.c, A5(oe, 1, n.b, n.c, A5(oe, 0, u.b, u.c, u.d, u.e), f), A5(oe, 1, a, o, c, b));
        }
        return n;
    }, ve = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, b = t.c, s = t.d, v = t.e, A5(oe, 1, e = n.b, u = n.c, A5(oe, 0, r.b, r.c, r.d, o = r.e), A5(oe, 0, c, b, s, v));
            }
            var e = n.b, u = n.c, i = n.d, a = i.d, o = i.e, f = n.e, c = f.b, b = f.c, s = f.d, v = f.e;
            return A5(oe, 0, i.b, i.c, A5(oe, 1, a.b, a.c, a.d, a.e), A5(oe, 1, e, u, o, A5(oe, 0, c, b, s, v)));
        }
        return n;
    }, de = F7(function(n, r, t, e, u, i, a) {
        if (-1 !== i.$ || i.a) {
            n: for(;;){
                if (-1 === a.$ && 1 === a.a) {
                    if (-1 === a.d.$) {
                        if (1 === a.d.a) return ve(r);
                        break n;
                    }
                    return ve(r);
                }
                break n;
            }
            return r;
        }
        return A5(oe, t, i.b, i.c, i.d, A5(oe, 0, e, u, i.e, a));
    }), le = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, i = u.d, a = n.e;
            if (1 === u.a) {
                if (-1 !== i.$ || i.a) {
                    var o = se(n);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(fe, o.a, o.b, o.c, le(o.d), f);
                    }
                    return re;
                }
                return A5(oe, r, t, e, le(u), a);
            }
            return A5(oe, r, t, e, le(u), a);
        }
        return re;
    }, ge = F2(function(n, r) {
        if (-2 === r.$) return re;
        var t = r.a, e = r.b, u = r.c, i = r.d, a = r.e;
        if (0 > o(n, e)) {
            if (-1 === i.$ && 1 === i.a) {
                var f = i.d;
                if (-1 !== f.$ || f.a) {
                    var c = se(r);
                    if (-1 === c.$) {
                        var b = c.e;
                        return A5(fe, c.a, c.b, c.c, A2(ge, n, c.d), b);
                    }
                    return re;
                }
                return A5(oe, t, e, u, A2(ge, n, i), a);
            }
            return A5(oe, t, e, u, A2(ge, n, i), a);
        }
        return A2(he, n, A7(de, n, r, t, e, u, i, a));
    }), he = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, o = r.e;
            if (i(n, e)) {
                var f = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === f.$ ? A5(fe, t, f.b, f.c, a, le(o)) : re;
            }
            return A5(fe, t, e, u, a, A2(ge, n, o));
        }
        return re;
    }), $e = F2(function(n, r) {
        var t = A2(ge, n, r);
        return -1 !== t.$ || t.a ? t : A5(oe, 1, t.b, t.c, t.d, t.e);
    }), me = F3(function(n, r, t) {
        var e = r(A2(ae, n, t));
        return e.$ ? A2($e, n, t) : A3(be, n, e.a, t);
    }), pe = F3(function(n, r, t) {
        return r(n(t));
    }), xe = F2(function(n, r) {
        return A3(wr, "", Tt, A2(pe, r, n));
    }), we = F2(function(n, r) {
        return r.$ ? Nr(n(r.a)) : Fr(r.a);
    }), ye = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ke = {
        $: 2
    }, Ee = {
        $: 1
    }, je = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Nr({
                    $: 0,
                    a: r.a
                });
            case 1:
                return Nr(Ee);
            case 2:
                return Nr(ke);
            case 3:
                return Nr({
                    $: 3,
                    a: r.a.bH
                });
            default:
                return A2(we, ye, n(r.b));
        }
    }), Ae = F2(function(n, r) {
        return A2(xe, n, je(function(n) {
            return A2(we, tt, A2(Zt, r, n));
        }));
    }), _e = {
        $: 0
    }, Le = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ne = F2(function(n, r) {
        return {
            a1: n,
            ba: r
        };
    }), Te = zt(A2(Ne, te, l)), ze = function(n) {
        return tn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(rn(0));
        });
    }, qe = on, Fe = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var i = e.a;
                    return A2(Jt, function(r) {
                        var e = i.bc;
                        return A3(Fe, n, u, 1 === e.$ ? t : A3(be, e.a, r, t));
                    }, qe(A3(pr, n, Pt(n), i)));
                }
                var a = e.a, o = A2(ae, a, t);
                if (1 === o.$) {
                    r = u;
                    continue n;
                }
                return A2(Jt, function() {
                    return A3(Fe, n, u, A2($e, a, t));
                }, ze(o.a));
            }
            return zt(t);
        }
    }), Ie = F4(function(n, r, t, e) {
        return A2(Jt, function(n) {
            return zt(A2(Ne, n, t));
        }, A3(Fe, n, r, e.a1));
    }), Ce = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(kr, e.a, t);
    }), Je = F2(function(n, r) {
        return A3(It, Ce(n), l, r);
    }), Oe = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? Jr(A2(Pt, n, u(t))) : Or;
    }), De = F3(function(n, r, t) {
        return A2(Jt, function() {
            return zt(t);
        }, Rt(A2(Je, A3(Oe, n, r.a, r.b), t.ba)));
    }), Re = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Le({
                bm: t.bm,
                bo: t.bo,
                aE: A2(yr, n, t.aE),
                aI: t.aI,
                bA: t.bA,
                bK: t.bK,
                bc: t.bc,
                be: t.be
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), Pe = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    ln.Http = gn(Te, Ie, De, Re, F2(function(n, r) {
        return A2(Pe, r.a, A2(pe, r.b, n));
    }));
    var Be = pn("Http"), Ge = (pn("Http"), function(n) {
        return function(n) {
            return Be(Le({
                bm: !1,
                bo: n.bo,
                aE: n.aE,
                aI: n.aI,
                bA: n.bA,
                bK: n.bK,
                bc: n.bc,
                be: n.be
            }));
        }({
            bo: _e,
            aE: n.aE,
            aI: l,
            bA: "GET",
            bK: Or,
            bc: Or,
            be: n.be
        });
    }), Me = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Se = F7(function(n, r, t, e, u, i, a) {
        return {
            i: t,
            bq: i,
            g: r,
            l: n,
            I: e,
            ak: a,
            am: u
        };
    }), He = C, Ye = M, Ze = {
        $: 0
    }, Ke = function(n) {
        return {
            $: 5,
            c: n
        };
    }, We = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Xe = function(n) {
        return We($([
            Ke(Or),
            A2(At, Jr, n)
        ]));
    }, Ue = F2(function(n, r) {
        return c(n, r);
    }), Qe = A2(jt, function(n) {
        var r = c(n.a, n.b);
        return Lt(r.a.$ || r.b.$ ? Ze : {
            $: 1,
            a: {
                i: r.b.a,
                g: r.a.a
            }
        });
    }, A3(_t, Ue, A2(Mt, "home_score", Xe(He)), A2(Mt, "away_score", Xe(He)))), Ve = Tt, nu = J, ru = Ge({
        aE: A2(Ae, Yt, Me(A8(Ye, Se, A2(Mt, "id", He), A2(Mt, "home", nu), A2(Mt, "away", nu), A2(At, function(n) {
            return Ve(1e3 * n);
        }, A2(Mt, "start_time", He)), A2(Mt, "venue", nu), A2(Mt, "city", nu), Qe))),
        be: "/api/matches"
    }), tu = Ge({
        aE: A2(Ae, function(n) {
            return {
                $: 2,
                a: n
            };
        }, Me(A7(G, F6(function(n, r, t, e, u, i) {
            return {
                E: u,
                bv: i,
                t: t,
                l: n,
                b: r,
                aW: e
            };
        }), A2(Mt, "id", He), A2(Mt, "name", nu), A2(Mt, "group", nu), A2(Mt, "pot", He), A2(Mt, "code", We($([
            nu,
            Ke("xx")
        ]))), A2(Mt, "fifa_code", We($([
            nu,
            Ke("XXX")
        ])))))),
        be: "/api/teams"
    }), eu = {
        $: 5
    }, uu = xn(l), iu = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), au = F2(function(n, r) {
        return {
            aU: r,
            ba: n
        };
    }), ou = zt(A2(au, l, te)), fu = function(n) {
        return c(d(n.a ? "w_" : "d_", n.b), n);
    }, cu = function(n) {
        return A3(Sr, F2(function(n, r) {
            return A3(be, n.a, n.b, r);
        }), te, n);
    }, bu = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, i = A3(n, t.b, t.c, A3(bu, n, r, t.d));
            n = u, r = i, t = e;
        }
    }), su = F6(function(n, r, t, e, u, i) {
        var a = A3(bu, F3(function(e, u, i) {
            n: for(;;){
                var a = i.a, f = i.b;
                if (a.b) {
                    var b = a.a, s = b.a, v = b.b, d = a.b;
                    if (0 > o(s, e)) {
                        i = c(d, A3(n, s, v, f));
                        continue n;
                    }
                    return o(s, e) > 0 ? c(a, A3(t, e, u, f)) : c(d, A4(r, s, v, u, f));
                }
                return c(a, A3(t, e, u, f));
            }
        }), c(jr(e), i), u), f = a.a, b = a.b;
        return A3(Sr, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), b, f);
    }), vu = F2(function(n, r) {
        return {
            aD: r,
            aP: n
        };
    }), du = F3(function(n, r, t) {
        return A2(Ot, function(n) {
            return c(r, n);
        }, A3($r, t.a ? hr : gr, t.b, function(t) {
            return A2(ue, n, A2(vu, r, t));
        }));
    }), lu = F2(function(n, r) {
        return A3(bu, be, r, n);
    });
    ln["Browser.Events"] = gn(ou, F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return b(e.a, e.b, A2(kr, A3(du, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return b(A2(kr, r, t.a), e, u);
        }), i = F4(function(n, r, t, e) {
            var u = e.c;
            return b(e.a, A3(be, n, r, e.b), u);
        }), a = A2(Ct, fu, r), o = A6(su, u, i, e, t.aU, cu(a), b(l, te, l)), f = o.b, c = o.c;
        return A2(Jt, function(n) {
            return zt(A2(au, a, A2(lu, f, cu(n))));
        }, A2(Jt, function() {
            return Rt(c);
        }, Rt(A2(Ct, ze, o.a))));
    }), F3(function(n, r, t) {
        var e = r.aP, u = r.aD, a = A2(Je, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(mr, r, u) : Or;
        }, t.ba);
        return A2(Jt, function() {
            return zt(t);
        }, Rt(A2(Ct, Pt(n), a)));
    }), 0, F2(function(n, r) {
        return A3(iu, r.a, r.b, A2(At, n, r.c));
    }));
    var gu, hu = pn("Browser.Events"), $u = A2(F3(function(n, r, t) {
        return hu(A3(iu, n, r, t));
    }), 0, "keydown"), mu = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), pu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, wu = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return function(a) {
                                return function(o) {
                                    return function(f) {
                                        return function(c) {
                                            return {
                                                Y: u,
                                                Z: i,
                                                _: a,
                                                aa: o,
                                                ab: f,
                                                ac: c,
                                                w: n,
                                                x: r,
                                                y: t,
                                                z: e
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, yu = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Or : Jr(A2(n, r.a, t.a));
    })(dt), ku = F2(function(n, r) {
        return A3(It, F2(function(r, t) {
            return n(r) ? A2(kr, r, t) : t;
        }), l, r);
    }), Eu = function(n) {
        return n.b ? Jr(n.a) : Or;
    }, ju = F3(function(n, r, t) {
        return Eu(A2(ku, function(n) {
            return i(n.g, r) && i(n.i, t) || i(n.g, t) && i(n.i, r);
        }, n));
    }), Au = x, _u = F2(function(n, r) {
        var t = A2(Au, function(n) {
            return n.aW;
        }, n);
        if (t.b && t.b.b && t.b.b.b && t.b.b.b.b && !t.b.b.b.b.b) {
            var e = t.a, u = t.b, i = u.a, a = u.b, o = a.a, f = a.b.a;
            return A2(yu, A3(ju, r, o.b, f.b), A2(yu, A3(ju, r, i.b, f.b), A2(yu, A3(ju, r, i.b, o.b), A2(yu, A3(ju, r, e.b, f.b), A2(yu, A3(ju, r, e.b, o.b), A2(yu, A3(ju, r, e.b, i.b), A2(yu, Jr(f), A2(yu, Jr(o), A2(yu, Jr(i), A2(yu, Jr(e), Jr(wu)))))))))));
        }
        return Or;
    }), Lu = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Nu = F2(function(n, r) {
        return r.$ ? Or : Jr(n(r.a));
    }), Tu = Ht(l), zu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), qu = function(n) {
        return A3(Sr, F2(function(n, r) {
            return A3(me, n.t, A2(pe, zu(l), A2(pe, kr(n), Jr)), r);
        }), te, n);
    }, Fu = F3(function(n, r, t) {
        for(;;){
            if (!r.b) return Jr(nt(t));
            var e = r.b, u = n(r.a);
            if (u.$) return Or;
            r = e, t = A2(kr, u.a, t);
        }
    }), Iu = F2(function(n, r) {
        return A3(Fu, n, r, l);
    }), Cu = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return c(r, Tu);
            case 1:
                if (n.a.$) return c(v(r, {
                    F: pu("Failed to load matches")
                }), Tu);
                var t = n.a.a, e = r.J;
                if (2 === e.$) {
                    n = A2(mu, u = e.a, t), r = v(r, {
                        F: xu(t)
                    });
                    continue n;
                }
                return c(v(r, {
                    F: xu(t)
                }), Tu);
            case 2:
                if (n.a.$) return c(v(r, {
                    J: pu("Failed to load teams")
                }), Tu);
                var u = n.a.a, i = r.F;
                if (2 === i.$) {
                    n = A2(mu, u, t = i.a), r = v(r, {
                        J: xu(u)
                    });
                    continue n;
                }
                return c(v(r, {
                    J: xu(u)
                }), Tu);
            case 3:
                t = n.b;
                var a = A2(Nu, cu, A2(Iu, function(n) {
                    var r = n.b;
                    return A2(Nu, Ue(n.a), A2(_u, r, t));
                }, jr(qu(u = n.a))));
                return c(v(r, a.$ ? {
                    T: pu("Failed to build groups")
                } : {
                    T: xu(a.a)
                }), Tu);
            case 4:
                return c(v(r, {
                    D: A2(kr, n.a, r.D)
                }), Tu);
            default:
                return c(v(r, {
                    D: A2(Lu, 1, r.D)
                }), Tu);
        }
    }), Ju = function(n) {
        return n;
    }, Ou = F2(function(n, r) {
        return A2(In, n, Ju(r));
    }), Du = Ou("className"), Ru = Tn("div"), Pu = Ln, Bu = Tn("h3"), Gu = Fn, Mu = F3(function(n, r, t) {
        return {
            q: n,
            r: r,
            m: t
        };
    }), Su = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Yu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zu = k, Ku = E, Wu = function(n) {
        return 6.283185307179586 * n;
    }, Xu = F3(function(n, r, t) {
        return {
            q: n.q + n.m * Zu(Wu(r - 1 / 4)),
            r: n.r + n.m * Ku(Wu(r - 1 / 4)),
            m: t
        };
    }), Uu = {
        L: "none",
        ad: "#464a5a",
        ae: "2"
    }, Qu = j, Vu = F2(function(n, r) {
        return 2 * Qu(r / (2 * n)) / 6.283185307179586;
    }), ni = Nn("http://www.w3.org/2000/svg"), ri = ni("circle"), ti = Cn("cx"), ei = Cn("cy"), ui = Cn("fill"), ii = F, ai = Cn("r"), oi = Cn("stroke"), fi = Cn("stroke-width"), ci = F2(function(n, r) {
        return A2(ri, $([
            ti(ii(n.q)),
            ei(ii(n.r)),
            ai(ii(n.m)),
            ui(r.L),
            oi(r.ad),
            fi(r.ae)
        ]), l);
    }), bi = Cn("class"), si = ni("g"), vi = ni("image"), di = Cn("width"), li = Cn("x"), gi = Cn("y"), hi = F2(function(n, r) {
        var t, e = 2 * r.m;
        return A2(si, $([
            bi("cursor-pointer transition ease-in-out hover:scale-110 origin-center [transform-box:fill-box]")
        ]), $([
            A2(vi, $([
                (t = "/badges/" + n + ".svg", A3(Jn, "http://www.w3.org/1999/xlink", "xlink:href", function(n) {
                    return Rn.test(n) ? "" : n;
                }(t))),
                li(ii(r.q - r.m)),
                gi(ii(r.r - r.m)),
                di(ii(e))
            ]), l),
            A2(ci, r, Uu)
        ]));
    }), $i = ni("foreignObject"), mi = Cn("height"), pi = F3(function(n, r, t) {
        return A2(si, $([
            bi("cursor-pointer transition ease-in-out hover:scale-110 origin-center [transform-box:fill-box]")
        ]), $([
            A2(ri, $([
                ti(ii(r.q)),
                ei(ii(r.r)),
                ai(ii(r.m)),
                ui(t.L),
                oi(t.ad),
                fi(t.ae)
            ]), l),
            A2($i, $([
                li(ii(r.q - r.m)),
                gi(ii(r.r - r.m / 2)),
                di(ii(2 * r.m)),
                mi(ii(r.m))
            ]), $([
                A2(Ru, $([
                    A2(Gu, "display", "flex"),
                    A2(Gu, "align-items", "center"),
                    A2(Gu, "justify-content", "center"),
                    A2(Gu, "width", "100%"),
                    A2(Gu, "height", "100%"),
                    A2(Gu, "font-size", ii(r.m) + "px"),
                    A2(Gu, "color", t.ad),
                    A2(Gu, "text-align", "center"),
                    A2(Gu, "line-height", "1")
                ]), $([
                    n
                ]))
            ]))
        ]));
    }), xi = ni("line"), wi = Cn("x1"), yi = Cn("x2"), ki = Cn("y1"), Ei = Cn("y2"), ji = F3(function(n, r, t) {
        var e = n.a, u = n.b, i = A3(Xu, A3(Mu, e, u, t), r, 0);
        return A2(xi, $([
            wi(ii(e)),
            ki(ii(u)),
            yi(ii(i.q)),
            Ei(ii(i.r)),
            oi("#464a5a"),
            fi("2")
        ]), l);
    }), Ai = F2(function(n, r) {
        return r.$ ? Or : n(r.a);
    }), _i = F3(function(n, r, t) {
        var e = function(n) {
            var t = n.ak;
            if (t.$) {
                var e = t.a, u = i(n.g, r) ? c(e.g, e.i) : c(e.i, e.g), a = u.a, f = u.b;
                return o(a, f) > 0 ? Jr(0) : 0 > o(a, f) ? Jr(1) : Jr(2);
            }
            return Or;
        }, u = function(n) {
            return i(n.g, r) && i(n.i, t) || i(n.g, t) && i(n.i, r);
        }, a = $([
            n.Y,
            n.Z,
            n._,
            n.aa,
            n.ab,
            n.ac
        ]);
        return A2(Ai, e, Eu(A2(ku, u, a)));
    }), Li = F2(function(n, r) {
        return A2(Cn, function(n) {
            return Dn.test(n) ? "data-" + n : n;
        }(n), Bn(r));
    }), Ni = F2(function(n, r) {
        return lt(n / r);
    }), Ti = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > o(e.au, r)) return r + e.c;
            t = u;
        }
    }), zi = F2(function(n, r) {
        var t = n.b;
        return A3(Ti, n.a, A2(Ni, r, 6e4), t);
    }), qi = function(n) {
        var r = A2(Ni, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, i = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), a = (5 * i + 2) / 153 | 0, o = a + (10 > a ? 3 : -9);
        return {
            aB: i - ((153 * a + 2) / 5 | 0) + 1,
            aR: o,
            bl: u + 400 * t + (o > 2 ? 0 : 1)
        };
    }, Fi = F2(function(n, r) {
        return qi(A2(zi, n, r)).aB;
    }), Ii = y, Ci = F2(function(n, r) {
        return A2(Ii, 24, A2(Ni, A2(zi, n, r), 60));
    }), Ji = F2(function(n, r) {
        return A2(Ii, 1e3, r);
    }), Oi = F2(function(n, r) {
        return A2(Ii, 60, A2(zi, n, r));
    }), Di = F2(function(n, r) {
        switch(qi(A2(zi, n, r)).aR){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), Ri = N, Pi = F3(function(n, r, t) {
        return n > 0 ? A3(Pi, n >> 1, d(r, r), 1 & n ? d(t, r) : t) : t;
    }), Bi = F2(function(n, r) {
        return A3(Pi, n, r, "");
    }), Gi = F3(function(n, r, t) {
        return d(A2(Bi, n - t.length, function(n) {
            return A2(Ri, n, "");
        }(r)), t);
    }), Mi = F2(function(n, r) {
        return A3(Gi, n, "0", Pr(r));
    }), Si = F2(function(n, r) {
        return A2(Ii, 60, A2(Ni, r, 1e3));
    }), Hi = F2(function(n, r) {
        return qi(A2(zi, n, r)).bl;
    }), Yi = A2(F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), 0, l), Zi = function(n) {
        return A2(Mi, 4, A2(Hi, Yi, n)) + "-" + A2(Mi, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(Di, Yi, n))) + "-" + A2(Mi, 2, A2(Fi, Yi, n)) + "T" + A2(Mi, 2, A2(Ci, Yi, n)) + ":" + A2(Mi, 2, A2(Oi, Yi, n)) + ":" + A2(Mi, 2, A2(Si, Yi, n)) + "." + A2(Mi, 3, A2(Ji, Yi, n)) + "Z";
    }, Ki = function(n) {
        return Tn(function(n) {
            return On.test(n) ? "p" : n;
        }(n));
    }, Wi = F2(function(n, r) {
        return A3(Ki, "relative-time", $([
            A2(Li, "datetime", Zi(r)),
            A2(Li, "format", "datetime"),
            A2(Li, "weekday", ""),
            A2(Li, "month", "numeric"),
            A2(Li, "day", "numeric"),
            A2(Li, "time-zone", n),
            A2(Li, "no-title", "")
        ]), $([
            Pu("")
        ]));
    }), Xi = qn, Ui = F2(function(n, r) {
        return A2(Xi, n, {
            $: 0,
            a: r
        });
    }), Qi = function(n) {
        return A2(Ui, "click", Lt(n));
    }, Vi = ni("svg"), na = Cn("viewBox"), ra = F2(function(n, r) {
        var t = A3(Mu, 400, 400, 0), e = 10, u = 35, i = A3(Xu, t, 0, 70), a = "#f8f7f7", o = function(n) {
            var r = function() {
                if (n.$) return a;
                switch(n.a){
                    case 0:
                        return "#2ea92e";
                    case 1:
                        return "#d52626";
                    default:
                        return "#ffdd41";
                }
            }();
            return v(Uu, {
                L: r
            });
        }, f = (v(Uu, {
            L: a
        }), v(Uu, {
            L: a,
            ae: "0"
        })), b = 300, s = A2(Vu, b, 70), d = A3(Xu, t, 0, 150), l = A3(Xu, t, 0, 230), g = A3(Xu, t, 0, b);
        return A2(Vi, $([
            na("0 0 800 800")
        ]), $([
            A2(ci, g, Uu),
            A3(ji, c(t.q, t.r), 0, b),
            A3(ji, c(t.q, t.r), 1 / 3, b),
            A3(ji, c(t.q, t.r), 2 / 3, b),
            A2(si, $([
                Qi(Hu(Yu(r.w.l)))
            ]), $([
                A2(ci, A3(Xu, g, 0, 60), f),
                A2(hi, r.w.E, A3(Xu, g, 0, 50))
            ])),
            A2(si, $([
                Qi(Hu(Yu(r.x.l)))
            ]), $([
                A2(ci, A3(Xu, t, 0, 60), f),
                A2(hi, r.x.E, A3(Xu, t, 0, 50))
            ])),
            A2(si, $([
                Qi(Hu(Yu(r.y.l)))
            ]), $([
                A2(ci, A3(Xu, g, 2 / 3, 60), f),
                A2(hi, r.y.E, A3(Xu, g, 2 / 3, 50))
            ])),
            A2(si, $([
                Qi(Hu(Yu(r.z.l)))
            ]), $([
                A2(ci, A3(Xu, g, 1 / 3, 60), f),
                A2(hi, r.z.E, A3(Xu, g, 1 / 3, 50))
            ])),
            A2(si, $([
                Qi(Hu(Su(r.Y.l)))
            ]), $([
                A3(pi, A2(Wi, n, r.Y.I), A3(Xu, d, 0, u), f)
            ])),
            A2(si, $([
                Qi(Hu(Su(r.Z.l)))
            ]), $([
                A3(pi, A2(Wi, n, r.Z.I), A3(Xu, g, 5 / 6, u), f)
            ])),
            A2(si, $([
                Qi(Hu(Su(r._.l)))
            ]), $([
                A3(pi, A2(Wi, n, r._.I), A3(Xu, g, 1 / 6, u), f)
            ])),
            A2(si, $([
                Qi(Hu(Su(r.aa.l)))
            ]), $([
                A3(pi, A2(Wi, n, r.aa.I), A3(Xu, d, 2 / 3, u), f)
            ])),
            A2(si, $([
                Qi(Hu(Su(r.ab.l)))
            ]), $([
                A3(pi, A2(Wi, n, r.ab.I), A3(Xu, d, 1 / 3, u), f)
            ])),
            A2(si, $([
                Qi(Hu(Su(r.ac.l)))
            ]), $([
                A3(pi, A2(Wi, n, r.ac.I), A3(Xu, g, .5, u), f)
            ])),
            A2(ci, A3(Xu, l, 0, e), o(A3(_i, r, r.w.b, r.x.b))),
            A2(ci, A3(Xu, g, -s, e), o(A3(_i, r, r.w.b, r.y.b))),
            A2(ci, A3(Xu, g, s, e), o(A3(_i, r, r.w.b, r.z.b))),
            A2(ci, A3(Xu, i, 0, e), o(A3(_i, r, r.x.b, r.w.b))),
            A2(ci, A3(Xu, i, 2 / 3, e), o(A3(_i, r, r.x.b, r.y.b))),
            A2(ci, A3(Xu, i, 1 / 3, e), o(A3(_i, r, r.x.b, r.z.b))),
            A2(ci, A3(Xu, g, 2 / 3 + s, e), o(A3(_i, r, r.y.b, r.w.b))),
            A2(ci, A3(Xu, l, 2 / 3, e), o(A3(_i, r, r.y.b, r.x.b))),
            A2(ci, A3(Xu, g, 2 / 3 - s, e), o(A3(_i, r, r.y.b, r.z.b))),
            A2(ci, A3(Xu, g, 1 / 3 - s, e), o(A3(_i, r, r.z.b, r.w.b))),
            A2(ci, A3(Xu, l, 1 / 3, e), o(A3(_i, r, r.z.b, r.x.b))),
            A2(ci, A3(Xu, g, 1 / 3 + s, e), o(A3(_i, r, r.z.b, r.y.b)))
        ]));
    }), ta = F3(function(n, r, t) {
        return A2(Ru, $([
            Du("bg-white rounded-lg p-4 shadow-sm"),
            A2(Gu, "background-color", "#f8f7f7")
        ]), $([
            A2(Bu, $([
                Du("font-bold text-lg mb-2 uppercase")
            ]), $([
                Pu("Group " + r)
            ])),
            A2(ra, n, t)
        ]));
    }), ea = F2(function(n, r) {
        return A2(Ru, $([
            Du("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4")
        ]), A2(Ct, function(r) {
            return A3(ta, n, r.a, r.b);
        }, jr(r)));
    }), ua = function(n) {
        var r = n.T;
        switch(r.$){
            case 1:
                var t = r.a;
                return A2(Ru, $([
                    Du("text-red-500")
                ]), $([
                    Pu(t)
                ]));
            case 2:
                return A2(ea, n.P, r.a);
            default:
                return A2(Ru, $([
                    Du("flex items-center gap-2 text-gray-500")
                ]), $([
                    A2(Ru, $([
                        Du("animate-spin rounded-full h-5 w-5 border-2 border-gray-300 border-t-blue-600")
                    ]), l),
                    Pu("Loading...")
                ]));
        }
    }, ia = function(n) {
        return A2(Ru, l, $([
            ua(n)
        ]));
    }, aa = {
        $: 0
    }, oa = Tn("button"), fa = F4(function(n, r, t, e) {
        return {
            i: t,
            g: r,
            aQ: n,
            am: e
        };
    }), ca = F2(function(n, r) {
        var t = c(n.F, n.J);
        if (2 === t.a.$ && 2 === t.b.$) {
            var e = t.b.a, u = Eu(A2(ku, function(n) {
                return i(n.l, r);
            }, t.a.a)), a = A2(Ai, function(n) {
                return Eu(A2(ku, function(r) {
                    return i(r.b, n.g);
                }, e));
            }, u), o = A2(Ai, function(n) {
                return Eu(A2(ku, function(r) {
                    return i(r.b, n.i);
                }, e));
            }, u);
            return A2(yu, A2(Nu, function(n) {
                return n.am;
            }, u), A2(yu, o, A2(yu, a, A2(yu, u, Jr(fa)))));
        }
        return Or;
    }), ba = function(n) {
        return A2(Ui, "click", Lt(n));
    }, sa = F2(function(n, r) {
        return A2(Xi, n, {
            $: 1,
            a: r
        });
    }), va = F2(function(n, r) {
        return {
            t: r,
            al: n
        };
    }), da = F2(function(n, r) {
        var t = b(n.F, n.J, n.T);
        if (2 === t.a.$ && 2 === t.b.$ && 2 === t.c.$) {
            var e = t.c.a, u = Eu(A2(ku, function(n) {
                return i(n.l, r);
            }, t.b.a));
            return A2(yu, A2(ae, A2(zu, "", A2(Nu, function(n) {
                return n.t;
            }, u)), e), A2(yu, u, Jr(va)));
        }
        return Or;
    }), la = Pu("card could not be loaded"), ga = Tn("img"), ha = function(n) {
        return A2(Ou, "src", Bn(n));
    }, $a = F2(function(n, r) {
        return A3(Ki, "relative-time", $([
            A2(Li, "datetime", Zi(r)),
            A2(Li, "format", "datetime"),
            A2(Li, "hour", "numeric"),
            A2(Li, "minute", "2-digit"),
            A2(Li, "time-zone-name", "short"),
            A2(Li, "time-zone", n),
            A2(Li, "no-title", "")
        ]), $([
            Pu("")
        ]));
    }), ma = F2(function(n, r) {
        return A2(Ru, $([
            Du("space-y-6")
        ]), $([
            A2(Ru, $([
                Du("flex items-center justify-between text-center")
            ]), $([
                A2(Ru, $([
                    Du("flex flex-col items-center gap-2 w-1/3")
                ]), $([
                    A2(ga, $([
                        ha("/badges/" + r.g.E + ".svg"),
                        Du("w-16 h-16 object-contain border border-black rounded-full")
                    ]), l),
                    A2(Ru, $([
                        Du("font-medium")
                    ]), $([
                        Pu(r.g.b)
                    ]))
                ])),
                A2(Ru, $([
                    Du("text-gray-400 text-sm font-semibold w-1/3")
                ]), $([
                    Pu("vs")
                ])),
                A2(Ru, $([
                    Du("flex flex-col items-center gap-2 w-1/3")
                ]), $([
                    A2(ga, $([
                        ha("/badges/" + r.i.E + ".svg"),
                        Du("w-16 h-16 object-contain border border-black rounded-full")
                    ]), l),
                    A2(Ru, $([
                        Du("font-medium")
                    ]), $([
                        Pu(r.i.b)
                    ]))
                ]))
            ])),
            A2(Ru, $([
                Du("text-sm text-gray-500 text-center space-y-1")
            ]), $([
                A2(Ru, l, $([
                    A2($a, n, r.aQ.I)
                ])),
                A2(Ru, l, $([
                    Pu(r.am)
                ]))
            ]))
        ]));
    }), pa = function(n) {
        return $([
            n.Y,
            n.Z,
            n._,
            n.aa,
            n.ab,
            n.ac
        ]);
    }, xa = F2(function(n, r) {
        var t = F2(function(n, r) {
            return o(n, r) > 0 ? 3 : i(n, r) ? 1 : 0;
        }), e = n.ak;
        if (e.$) {
            var u = e.a;
            return i(n.g, r) ? Jr(A2(t, u.g, u.i)) : i(n.i, r) ? Jr(A2(t, u.i, u.g)) : Or;
        }
        return Or;
    }), wa = F2(function(n, r) {
        var t;
        return t = A2(Je, function(n) {
            return A2(xa, n, r);
        }, pa(n)), A3(Sr, Cr, 0, t);
    }), ya = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), ka = F2(function(n, r) {
        return A2(ya, function(r) {
            return i(r, n);
        }, r);
    }), Ea = F2(function(n, r) {
        return Hr(A2(ku, function(n) {
            return A2(ka, r, $([
                n.g,
                n.i
            ])) && i(n.ak, Ze);
        }, pa(n)));
    }), ja = F2(function(n, r) {
        var t = A2(wa, n, r);
        return c(t, t + 3 * A2(Ea, n, r));
    }), Aa = F2(function(n, r) {
        var t = A2(ja, n, r);
        return (t.a + t.b) / 2;
    }), _a = F2(function(n, r) {
        var t = function() {
            if (r.$) {
                var t = A2(da, n, r.a);
                return t.$ ? la : (e = t.a, i = function(n) {
                    var r, t;
                    return A2(Ru, $([
                        Du("grid grid-cols-4 gap-2 text-sm py-1 border-b border-gray-100 last:border-0")
                    ]), $([
                        A2(Ru, $([
                            Du("font-medium truncate")
                        ]), $([
                            Pu(n)
                        ])),
                        A2(Ru, $([
                            Du("text-gray-600 text-right")
                        ]), $([
                            Pu(Pr(A2(wa, e.t, n)))
                        ])),
                        A2(Ru, $([
                            Du("text-gray-500 text-right")
                        ]), $([
                            Pu(Pr(A2(Ea, e.t, n)))
                        ])),
                        A2(Ru, $([
                            Du("text-gray-500 text-right")
                        ]), $([
                            Pu((r = A2(ja, e.t, n), t = r.b, Pr(r.a) + " to " + Pr(t)))
                        ]))
                    ]));
                }, A2(Ru, $([
                    Du("space-y-4")
                ]), $([
                    A2(Ru, $([
                        Du("flex items-center gap-4")
                    ]), $([
                        A2(ga, $([
                            ha("/badges/" + e.al.E + ".svg"),
                            Du("w-12 h-12 object-contain border border-black rounded-full")
                        ]), l),
                        A2(Ru, l, $([
                            A2(Ru, $([
                                Du("text-lg font-semibold")
                            ]), $([
                                Pu(e.al.b)
                            ])),
                            A2(Ru, $([
                                Du("text-sm text-gray-500")
                            ]), $([
                                Pu("Group " + e.al.t)
                            ]))
                        ]))
                    ])),
                    A2(Ru, $([
                        Du("text-sm font-semibold text-gray-700 uppercase tracking-wide")
                    ]), $([
                        Pu("Group standings")
                    ])),
                    A2(Ru, $([
                        Du("grid grid-cols-4 gap-2 text-xs text-gray-400 uppercase")
                    ]), $([
                        A2(Ru, l, $([
                            Pu("Team")
                        ])),
                        A2(Ru, $([
                            Du("text-right")
                        ]), $([
                            Pu("Points")
                        ])),
                        A2(Ru, $([
                            Du("text-right")
                        ]), $([
                            Pu("Games Left")
                        ])),
                        A2(Ru, $([
                            Du("text-right")
                        ]), $([
                            Pu("Final Point Range")
                        ]))
                    ])),
                    A2(Ru, l, A2(Ct, i, A2(Au, function(n) {
                        return -A2(Aa, e.t, n);
                    }, A2(Ct, function(n) {
                        return n.b;
                    }, (u = e.t, $([
                        u.w,
                        u.x,
                        u.y,
                        u.z
                    ]))))))
                ])));
            }
            var e, u, i, a = A2(ca, n, r.a);
            return a.$ ? la : A2(ma, n.P, a.a);
        }();
        return A2(Ru, $([
            Du("fixed inset-0 flex items-center justify-center"),
            ba(eu)
        ]), $([
            A2(Ru, $([
                Du("relative w-xl max-w-[90vw] bg-white rounded-2xl shadow-2xl ring-1 ring-black/5 transition-all duration-300 ease-in-out p-6 "),
                A2(sa, "click", Lt(c(aa, !0)))
            ]), $([
                A2(oa, $([
                    Du("absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-xl leading-none"),
                    ba(eu)
                ]), $([
                    Pu("\xd7")
                ])),
                t
            ]))
        ]));
    }), La = Tn("h1"), Na = Tn("h2"), Ta = Tn("p"), za = A2(Ru, $([
        Du("max-w-7xl mx-auto px-6 pt-10 pb-6 text-center")
    ]), $([
        A2(Ta, $([
            Du("text-[11px] md:text-xs uppercase tracking-[0.24em] text-zinc-500 font-medium")
        ]), $([
            Pu("2026 Tournament Explorer")
        ])),
        A2(La, $([
            Du("mt-4 text-4xl md:text-5xl font-semibold tracking-tight text-zinc-950 font-display")
        ]), $([
            Pu("World Cup Atlas")
        ])),
        A2(Ru, $([
            Du("mt-8 flex items-center justify-center gap-6")
        ]), $([
            A2(Ru, $([
                Du("hidden sm:block h-px w-28 md:w-44 bg-zinc-200")
            ]), l),
            A2(Na, $([
                Du("text-lg md:text-xl font-medium tracking-tight text-zinc-600")
            ]), $([
                Pu("Group Stage")
            ])),
            A2(Ru, $([
                Du("hidden sm:block h-px w-28 md:w-44 bg-zinc-200")
            ]), l)
        ]))
    ]));
    gu = {
        Main: {
            init: Gt({
                by: function(n) {
                    return c({
                        D: l,
                        T: St,
                        F: St,
                        J: St,
                        P: n.P
                    }, Ht($([
                        ru,
                        tu
                    ])));
                },
                bJ: function(n) {
                    return Hr(n.D) > 0 ? $u(A2(jt, function(n) {
                        return "Escape" === n ? Lt(eu) : {
                            $: 1,
                            a: "not escape"
                        };
                    }, A2(Mt, "key", nu))) : uu;
                },
                bM: Cu,
                bN: function(n) {
                    var r, t = (r = Eu(n.D)).$ ? Pu("") : A2(_a, n, r.a);
                    return A2(Ru, $([
                        Du("p-8")
                    ]), $([
                        za,
                        t,
                        ia(n)
                    ]));
                }
            })(A2(jt, function(n) {
                return Lt({
                    P: n
                });
            }, A2(Mt, "timeZone", nu)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, gu) : n.Elm = gu;
}($8c375ce4d4f5e09f$exports);


const $dad545c909cfec2d$var$browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
(0, $8c375ce4d4f5e09f$exports.Elm).Main.init({
    node: document.getElementById("app"),
    flags: {
        timeZone: $dad545c909cfec2d$var$browserTimeZone
    }
});


//# sourceMappingURL=path0.eb96de1a.js.map
